import { RU_PACK_NAMES } from './packLabels'

export type Locale = 'ru' | 'en'

export const LOCALE_STORAGE_KEY = 'hmvm:reviewer:locale'

type Dict = Record<string, string>

const ru: Dict = {
  'nav.dashboard': 'Обзор',
  'nav.projects': 'Проекты',
  'nav.audits': 'Проверки',
  'nav.auditDetails': 'Проверка',
  'nav.findings': 'Находки',
  'nav.findingDetails': 'Находка',
  'nav.evidence': 'Доказательства',
  'nav.scores': 'Оценки',
  'nav.reports': 'Отчёты',
  'nav.fixWithAi': 'Исправить с ИИ',
  'nav.reAudit': 'Ещё раз',
  'nav.knowledgeBase': 'База знаний',
  'nav.knowledgeControl': 'Управление знаниями',
  'nav.knowledgePacks': 'Пакеты правил',
  'nav.packControl': 'Пакет',
  'nav.ruleControl': 'Правило',
  'nav.settings': 'Настройки',

  'group.overview': 'Главное',
  'group.projectsAudits': 'Проекты и проверки',
  'group.investigation': 'Разбор',
  'group.analysis': 'Итоги',
  'group.ai': 'Автоматика',
  'group.knowledge': 'Знания',
  'group.admin': 'Админ',

  'status.completed': 'готово',
  'status.running': 'идёт',
  'status.pending': 'ждёт',
  'status.queued': 'в очереди',
  'status.failed': 'ошибка',
  'status.partial': 'частично',
  'status.cancelled': 'отменено',
  'status.timeout': 'таймаут',
  'status.open': 'открыто',
  'status.acknowledged': 'принято',
  'status.resolved': 'закрыто',
  'status.false_positive': 'ложное',
  'status.wont_fix': 'не чиним',
  'status.duplicate': 'дубль',
  'status.investigating': 'смотрим',
  'status.generating': 'собираем',
  'status.success': 'успех',

  'severity.critical': 'критично',
  'severity.high': 'высоко',
  'severity.medium': 'средне',
  'severity.low': 'низко',
  'severity.info': 'справка',

  'track.code_quality': 'Качество кода',
  'track.security': 'Безопасность',
  'track.api': 'API',
  'track.infrastructure': 'Инфраструктура',
  'track.business_logic': 'Бизнес-логика',
  'track.e2e_ui': 'Интерфейс',
  'track.performance': 'Нагрузка',
  'track.ai_code_risk': 'Риск ИИ-кода',

  'common.loading': 'Загрузка…',
  'common.error': 'Ошибка',
  'common.back': 'Назад',
  'common.save': 'Сохранить',
  'common.cancel': 'Отмена',
  'common.search': 'Поиск',
  'common.close': 'Закрыть',
  'common.offline': 'Нет связи',
  'common.selectProject': 'Выбрать проект',
  'common.theme': 'Тема',
  'common.accent': 'Акцент',
  'common.signingIn': 'Входим через HMVMAuth…',
  'common.generate': 'Собрать',
  'common.download': 'Скачать',
  'common.refresh': 'Обновить',
  'common.create': 'Создать',
  'common.start': 'Запустить',
  'common.retry': 'Ещё раз',
  'common.expandSidebar': 'Показать меню',
  'common.collapseSidebar': 'Свернуть меню',
  'common.breadcrumb': 'Путь',
  'common.sso': 'Вход / Telegram',
  'common.logout': 'Выход',
  'common.authHome': 'Единый вход',
  'common.viewFindings': 'К находкам',
  'common.total': 'Всего',
  'common.version': 'версия',

  'lang.ru': 'RUS',
  'lang.en': 'EN',
  'lang.switch': 'Язык интерфейса',

  'review.what': 'Что это',
  'review.why': 'Почему это важно',
  'review.where': 'Где смотреть',
  'review.fix': 'Как закрыть',
  'review.snippet': 'Фрагмент кода',
  'review.impact': 'Что будет, если не чинить',
  'review.details': 'Карточка',
  'review.location': 'Файл',
  'review.reproduction': 'Как повторить',
  'review.remediation': 'Исправление',
  'review.effort': 'Объём работ',
  'review.confidence': 'Уверенность',
  'review.related': 'Похожие находки',

  'page.dashboard': 'Обзор',
  'page.dashboardLead': 'Сначала закройте критичные дыры. Остальное можно планировать.',
  'page.projects': 'Проекты',
  'page.projectsLead': 'Сюда кладёте git или ZIP. Дальше запускаете проверку.',
  'page.audits': 'Проверки',
  'page.auditsLead': 'Каждая проверка — снимок кода и список находок.',
  'page.findings': 'Находки',
  'page.findingsLead': 'Очередь разбора: сначала критичное, потом высокое.',
  'page.evidence': 'Доказательства',
  'page.evidenceLead': 'Куски кода, на которых держится вывод.',
  'page.scores': 'Оценки',
  'page.scoresLead': 'Риск, долг и соответствие — три цифры по проверке.',
  'page.reports': 'Отчёты',
  'page.reportsLead': 'Технический обзор для человека: суть, риск, где чинить.',
  'page.settings': 'Настройки',
  'page.settingsLead': 'Тема и привычки скана. Язык — кнопка RUS | EN справа вверху.',
  'page.fixAi': 'Исправить с ИИ',
  'page.reAudit': 'Повторная проверка',
  'page.knowledgeBase': 'База знаний',
  'page.knowledgeControl': 'Управление знаниями',
  'page.knowledgePacks': 'Пакеты правил',

  'dash.risk': 'Риск сейчас',
  'dash.attention': 'Нужно внимание',
  'dash.recommended': 'Что делать дальше',
  'dash.recent': 'Последние проверки',
  'dash.firstTitle': 'Пока пусто',
  'dash.firstBody': 'Создайте проект и запустите первую проверку. Отчёт появится здесь.',
  'dash.startAudit': 'Запустить проверку',
  'dash.newProject': 'Новый проект',
  'dash.failedLoad': 'Не удалось загрузить обзор',
  'dash.viewCritical': 'Критичные',
  'dash.viewHigh': 'Высокие',

  'audit.totalFindings': 'Всего находок',
  'audit.critical': 'Критично',
  'audit.high': 'Высоко',
  'audit.mediumLow': 'Средне + низко',
  'audit.tasks': 'Задачи',
  'audit.timeline': 'Ход проверки',
  'audit.scores': 'Оценки',
  'audit.openReports': 'Отчёт',
  'audit.run': 'Проверка',

  'findings.empty': 'Находок нет',
  'findings.emptyHint': 'Смените фильтр или дождитесь конца проверки.',
  'findings.filters': 'Фильтры',
  'findings.advanced': 'Ещё фильтры',
  'findings.title': 'Заголовок',
  'findings.severity': 'Серьёзность',
  'findings.status': 'Статус',
  'findings.project': 'Проект',
  'findings.failedLoad': 'Не удалось загрузить находки',

  'dialog.startTitle': 'Новая проверка',
  'dialog.startLead': 'Выберите проект и что проверять. ИИ можно выключить.',
  'dialog.selectProjectFirst': 'Сначала выберите проект',
  'dialog.selectTrack': 'Выберите хотя бы один трек',
  'dialog.tracks': 'Что проверять',
  'dialog.packs': 'Пакеты правил (необязательно)',
  'dialog.quickScan': 'Быстрый скан',
  'dialog.includeAi': 'ИИ-разбор',
  'dialog.createTitle': 'Новый проект',
  'dialog.nameRequired': 'Нужно имя проекта',
  'dialog.repoRequired': 'Нужен URL репозитория',
  'dialog.zipRequired': 'Выберите ZIP',
  'dialog.stagingRequired': 'Нужен URL стенда',
  'dialog.displayName': 'Имя',
  'dialog.description': 'Заметка',
  'dialog.git': 'Git',
  'dialog.zip': 'ZIP',
  'dialog.staging': 'Стенд',
  'dialog.repoUrl': 'URL репозитория',
  'dialog.gitRef': 'Ветка / тег',
  'dialog.stagingUrl': 'URL стенда',

  'reports.recent': 'Недавние отчёты',
  'reports.pickRun': 'Выберите проверку',
  'reports.none': 'Отчётов ещё нет',
  'reports.failedLoad': 'Не удалось загрузить отчёты',
  'reports.failedGenerate': 'Не удалось собрать отчёт',
  'reports.technical': 'Технический обзор',

  'settings.themeBase': 'Светлая / тёмная',
  'settings.themeAccent': 'Цвет акцента',
  'settings.appearance': 'Вид',
  'settings.lead': 'Тема и привычки. Язык — кнопка RUS | EN справа вверху.',
  'settings.projects': 'Проекты',
  'settings.projectsLead': 'Удаление загруженного проекта вместе с прогонами, находками и отчётами. Это необратимо.',
  'settings.noProjects': 'Проектов нет',
  'settings.runs': 'Прогоны',
  'settings.deleteProject': 'Удалить проект',
  'settings.deleteRun': 'Удалить прогон',
  'settings.confirmProjectTitle': 'Удалить проект',
  'settings.confirmProjectBody': 'Будут удалены все прогоны, находки, доказательства и отчёты этого проекта. Чтобы подтвердить, введите имя проекта.',
  'settings.confirmName': 'Имя проекта',
  'settings.confirmRunTitle': 'Удалить прогон',
  'settings.confirmRunBody': 'Прогон, его находки и отчёты будут удалены. Проект останется.',
  'settings.deleteForever': 'Удалить навсегда',
  'settings.deleted': 'Удалено',
  'settings.auditsCount': 'прогонов',
  'settings.themeDark': 'Тёмная',
  'settings.themeLight': 'Светлая',
  'settings.themeSystem': 'Как в системе',

  'dash.title': 'Обзор безопасности',
  'dash.loading': 'Загрузка обзора…',
  'dash.loadFailed': 'Не удалось загрузить обзор',
  'dash.welcome': 'Пока пусто. Создайте проект и запустите первую проверку — отчёт появится здесь.',
  'dash.startFirst': 'Первая проверка',
  'dash.addProject': 'Новый проект',
  'dash.startAuditBtn': 'Запустить проверку',
  'dash.lead': 'Сначала закройте критичные дыры. Остальное можно планировать.',
  'dash.overallRisk': 'Риск сейчас',
  'dash.critHigh': 'Критично и высоко',
  'dash.auditHealth': 'Здоровье проверок',
  'dash.requiresAttention': 'Нужно внимание',
  'dash.distribution': 'Распределение',
  'dash.recentActivity': 'Последние проверки',
  'dash.noAttention': 'Критичного и высокого нет',
  'dash.legendCritical': 'Критично',
  'dash.legendHigh': 'Высоко',
  'dash.legendMedium': 'Средне',
  'dash.legendLow': 'Низко',
  'dash.legendInfo': 'Справка',
  'dash.totalFindingsKpi': 'Всего находок',
  'dash.acrossAudits': 'Текущий снимок (последний прогон по проекту)',
  'dash.clickView': 'Открыть →',
  'dash.viewAll': 'Все →',
  'dash.recommendedBadge': 'Дальше',
  'dash.noFindingsDisplay': 'Пока пусто',
  'dash.noRecent': 'Нет недавних проверок',
  'dash.findingOne': 'находка',
  'dash.findingsMany': 'находок',
  'dash.noData': 'Нет данных',
  'dash.noDataBody': 'Не удалось получить статистику.',
  'dash.critShort': 'крит',
  'dash.highShort': 'выс',
  'dash.projectsShort': 'проекты',
  'dash.doneShort': 'готово',
  'dash.runningShort': 'идёт',
  'dash.failedShort': 'ошибка',
  'dash.viewCritHigh': 'Открыть критичные и высокие',
  'dash.viewAllFindings': 'Открыть все находки',
  'dash.viewAllAudits': 'Все проверки',
  'dash.attentionAria': 'Нужно внимание',
  'dash.riskAria': 'Риск сейчас',
  'dash.distAria': 'Распределение',
  'dash.recentAria': 'Последние проверки',
  'dash.recAria': 'Что делать дальше',

  'finding.loading': 'Загрузка находки…',
  'finding.error': 'Не удалось открыть находку',
  'finding.backAria': 'Назад к списку',
  'finding.evidence': 'Доказательства',
  'finding.noEvidence': 'Доказательств нет',
  'finding.noEvidenceBody': 'К этой находке нет куска кода, или его уже удалили по политике хранения.',
  'finding.primary': 'Основное',
  'finding.destroyed': 'Кусок кода недоступен или уже удалён.',
  'finding.stored': 'Доказательство лежит отдельно',
  'finding.ruleProvenance': 'Правило',
  'finding.ruleId': 'ID правила',
  'finding.source': 'Источник',
  'finding.viewKb': 'В базе знаний',
  'finding.auditContext': 'Контекст проверки',
  'finding.related': 'Похожие находки',
  'finding.viewAllRelated': 'Все похожие',
  'finding.loadingRelated': 'Загрузка похожих…',
  'finding.project': 'Проект',
  'finding.auditRun': 'Проверка',
  'finding.tracks': 'Треки',
  'finding.completed': 'Готово',
  'finding.securityIds': 'Идентификаторы',
  'finding.tags': 'Теги',
  'finding.timestamps': 'Время',
  'finding.created': 'Создано',
  'finding.firstSeen': 'Впервые',
  'finding.lastSeen': 'Последний раз',
  'finding.script': 'Скрипт',
  'finding.audit': 'Проверка',

  'findings.loading': 'Загрузка находок…',
  'findings.count': '{n} находок в текущем снимке',
  'findings.countAll': '{n} находок по всем прогонам',
  'findings.searchPh': 'Поиск по заголовку, тексту, файлу…',
  'findings.allStatuses': 'Все статусы',
  'findings.allConfidence': 'Любая уверенность',
  'findings.showAdvanced': 'Ещё фильтры',
  'findings.hideAdvanced': 'Скрыть фильтры',
  'findings.clearAll': 'Сбросить',
  'findings.emptyTitle': 'Находок нет',
  'findings.noMatching': 'Нет подходящих находок',
  'findings.tableAria': 'Таблица находок',
  'findings.colCreated': 'Создано',
  'findings.searchAria': 'Поиск находок',
  'findings.statusAria': 'Фильтр по статусу',
  'findings.confidenceAria': 'Фильтр по уверенности',
  'findings.clearAria': 'Сбросить фильтры',
  'findings.filtered': '(фильтр)',
  'findings.category': 'Категория',
  'findings.projectId': 'ID проекта',
  'findings.auditId': 'ID проверки',
  'findings.colTrack': 'Трек',
  'findings.colLocation': 'Файл',
  'findings.filterSeverityAria': 'Фильтр серьёзности: {severity}',
  'findings.filterTrackAria': 'Фильтр по треку',
  'findings.filterCategoryAria': 'Фильтр по категории',
  'findings.filterProjectAria': 'Фильтр по проекту',
  'findings.filterAuditAria': 'Фильтр по проверке',
  'findings.trackPh': 'например, security',
  'findings.categoryPh': 'например, vulnerability',
  'findings.uuidPh': 'UUID',
  'findings.summarySeverities': '{n} уровней серьёзности',
  'findings.summaryStatus': 'Статус: {v}',
  'findings.summaryConfidence': 'Уверенность: {v}',
  'findings.summaryTrack': 'Трек: {v}',
  'findings.summaryCategory': 'Категория: {v}',
  'findings.summarySearch': 'Поиск: «{v}»',
  'findings.rowAria': 'Находка: {title}, серьёзность: {severity}, статус: {status}',
  'findings.noMatchingBody': 'Нет находок по текущим фильтрам. Сбросьте или ослабьте фильтр.',
  'findings.emptyBody': 'Находок ещё нет. Сначала запустите проверку.',
  'conf.high': 'высокая',
  'conf.medium': 'средняя',
  'conf.low': 'низкая',
  'conf.uncertain': 'неясная',

  'reports.title': 'Отчёты',
  'reports.auditTitle': 'Отчёт проверки',
  'reports.loading': 'Загрузка отчётов…',
  'reports.indexLead': 'Технический обзор: суть, риск, где чинить. HTML, PDF или JSON.',
  'reports.generateNew': 'Новый отчёт',
  'reports.generateLead': 'HTML — инженеру (разворачиваемые находки). PDF — бизнесу (обзор без кода). JSON — экспорт.',
  'reports.generateHtml': 'HTML — инженеру',
  'reports.generatePdf': 'PDF — бизнесу',
  'reports.generateJson': 'JSON — экспорт',
  'reports.generating': 'Собираем…',
  'reports.notAvailable': 'Отчёт пока нельзя',
  'reports.notAvailableBody': 'Отчёт можно собрать, когда проверка закончилась, оборвалась или упала. Сейчас статус: {status}.',
  'reports.generated': 'Готовые отчёты',
  'reports.noneYet': 'Отчётов ещё нет. Соберите первый выше.',
  'reports.backAudit': '← К проверке',
  'reports.backDash': '← К обзору',
  'reports.downloadFail': 'Не удалось скачать: {msg}',
  'reports.generateFail': 'Не удалось собрать отчёт: {msg}',
  'reports.notFound': 'Отчёт не найден',
  'reports.htmlHint': 'HTML и JSON сразу. PDF чуть дольше. PDF не содержит сниппетов кода.',
  'findings.scopeCurrent': 'Текущий снимок',
  'findings.scopeAll': 'Все прогоны',
  'findings.scopeAria': 'Область находок',
  'findings.triage': 'Статус',
  'findings.triageAria': 'Сменить статус находки',
  'findings.triageSaved': 'Статус обновлён',
  'findings.triageFailed': 'Не удалось сменить статус',
  'findings.filterTrack': 'Трек',
  'findings.filterCategory': 'Категория',
  'findings.filterProject': 'ID проекта',
  'findings.filterAudit': 'ID прогона',
  'findings.severitiesN': '{n} серьёзностей',
  'findings.activeStatus': 'Статус: {v}',
  'findings.activeConfidence': 'Уверенность: {v}',
  'findings.activeTrack': 'Трек: {v}',
  'findings.activeCategory': 'Категория: {v}',
  'findings.activeSearch': 'Поиск: «{v}»',
  'findings.openQueue': 'Открытые',
  'settings.clearTokenConfirm': 'Убрать админ-токен с этой вкладки?',
  'reports.fromAudit': 'Собрать из проверки',
  'reports.findingsDot': '{n} находок · {when}',
  'reports.goAudits': 'К проверкам',
  'reports.noneIndex': 'Отчётов ещё нет',
  'reports.noneIndexBody': 'Сначала дождитесь конца проверки, потом соберите обзор.',

  'dialog.startTitleUi': 'Запустить проверку',
  'dialog.starting': 'Запускаем…',
  'dialog.cancel': 'Отмена',
  'dialog.selectProject': 'Выберите проект',
  'dialog.tracksLegend': 'Что проверять',
  'dialog.noProjects': 'Сначала создайте проект.',
  'dialog.project': 'Проект',
  'dialog.packsLegend': 'Пакеты правил (только ACTIVE)',
  'dialog.noActivePacks': 'ACTIVE-пакетов нет. Проверка возьмёт все ACTIVE-правила.',
  'dialog.leavePacks': 'Ничего не отмечено — берутся все ACTIVE-правила.',
  'dialog.createTitleUi': 'Новый проект',
  'dialog.creating': 'Создаём…',

  'projects.loading': 'Загрузка проектов…',
  'projects.failed': 'Не удалось загрузить проекты',
  'projects.empty': 'Проектов ещё нет',
  'projects.emptyBody': 'Добавьте git, ZIP или стенд — и запускайте проверку.',

  'audits.loading': 'Загрузка проверок…',
  'audits.failed': 'Не удалось загрузить проверки',
  'audits.empty': 'Проверок ещё нет',
  'audits.emptyBody': 'Запустите проверку из проекта. Статус появится здесь.',
  'audits.back': 'К списку проверок',

  'packs.lead': 'Наборы правил с версиями. Включить пакет можно только через Управление знаниями.',
  'packs.editMeta': 'Править карточку',
  'packs.saveMeta': 'Сохранить',
  'packs.members': 'Правила в пакете',
  'packs.addMember': 'Добавить правило',
  'packs.removeMember': 'Убрать',
  'packs.noMembers': 'Правил в пакете нет',
  'packs.noMembersBody': 'Сначала привяжите активные правила, иначе проверка не пройдёт.',
  'packs.memberId': 'UUID правила в базе',
  'packs.newVersion': 'Новая версия',
  'packs.copyDraft': 'Скопировать в черновик',
  'packs.history': 'История',
  'packs.noHistory': 'Переходов ещё не было.',
  'packs.previewResolve': 'Как пойдёт в проверку',
  'packs.confirmBody': 'Действие пишется в историю пакета. Кто нажал — берётся из входа, не из формы.',
  'packs.colActive': 'Активно',
  'packs.yes': 'да',
  'packs.no': 'нет',
  'packs.backControl': 'К управлению знаниями',
  'packs.total': 'всего пакетов {n}',
  'packs.active': 'активных {n}',
  'packs.search': 'Поиск пакетов…',
  'packs.statusAria': 'Статус пакета',
  'packs.groupAria': 'Группа пакета',
  'packs.create': 'Создать пакет',
  'packs.clearToken': 'Сбросить токен',
  'packs.loading': 'Загрузка пакетов…',
  'packs.failed': 'Не удалось загрузить пакеты',
  'packs.empty': 'В этой очереди пакетов нет',
  'packs.emptyFilter': 'Смените фильтр',
  'packs.emptyCreate': 'Создайте черновик пакета',
  'packs.colPack': 'Пакет',
  'packs.colStatus': 'Статус',
  'packs.colValidation': 'Проверка',
  'packs.colMembers': 'Правил',
  'packs.colFormat': 'Формат',
  'packs.colTags': 'Метки',
  'packs.prev': 'Назад',
  'packs.next': 'Дальше',
  'packs.page': 'Страница {page} из {total} ({count})',
  'packs.createTitle': 'Новый пакет правил',
  'packs.creating': 'Создаём…',
  'packs.createDraft': 'Создать черновик',
  'packs.tokenLead': 'Нужен админский вход. Тот же токен, что и в Управлении знаниями.',
  'packs.tokenLabel': 'Админ-токен',
  'packs.authenticate': 'Войти',
  'packs.fieldPackId': 'id пакета',
  'packs.fieldVersion': 'версия',
  'packs.fieldName': 'название',
  'packs.fieldFormat': 'формат',
  'packs.fieldDescription': 'описание',

  'kc.lead': 'Очередь человека. ИИ сам пакеты не включает.',
  'kc.matchSpec': 'Спека правила',
  'kc.authRequired': 'Нужен вход администратора',
  'kc.tokenLead': 'Нужен админский вход. Вставьте токен Управления знаниями. Он живёт только в этой вкладке, в сборку фронта не попадает.',
  'kc.tokenLabel': 'Админ-токен',
  'kc.authenticate': 'Войти',
  'kc.loading': 'Загрузка Управления знаниями…',
  'kc.failed': 'Не удалось загрузить Управление знаниями',
  'kc.search': 'Поиск правил…',
  'kc.statusAria': 'Статус жизненного цикла',
  'kc.empty': 'В этой очереди правил нет',
  'kc.emptyFilter': 'Смените фильтр',
  'kc.emptyQueue': 'Очередь Управления знаниями пуста',
  'kc.colRule': 'Правило',
  'kc.colRuleEn': 'Rule',
  'kc.colActions': 'Действия',
  'kc.statDraft': 'Черновик',
  'kc.statTesting': 'Тест',
  'kc.statReady': 'Готово',
  'kc.statTotal': 'Всего',
  'kc.statPacks': 'Пакеты',
  'kc.openPacks': 'Пакеты правил',
  'kc.notFound': 'Правило не найдено',
  'kc.rationale': 'Зачем предложили',

  'kb.lead': 'Готовые правила и как чинить. Показываются только активные пакеты и правила.',
  'kb.loading': 'Загрузка базы знаний…',
  'kb.failed': 'Не удалось загрузить базу знаний',
  'kb.activePacks': 'Активные пакеты',
  'kb.packLine': '{name} ({id}@{version}, {n} правил)',
  'kb.totalEntries': 'Всего записей',
  'kb.categories': 'Категории',
  'kb.formats': 'Форматы',
  'kb.search': 'Поиск правил…',
  'kb.allSeverities': 'Все уровни',
  'kb.allCategories': 'Все категории',
  'kb.allFormats': 'Все форматы',
  'kb.clearFilters': 'Сбросить фильтры',
  'kb.showing': 'Показано {shown} из {total}',
  'kb.emptyFilter': 'Ничего не подошло',
  'kb.emptyTitle': 'Записей нет',
  'kb.empty': 'В базе знаний пока пусто',
  'kb.hasFix': 'Есть как чинить',
  'kb.ruleId': 'ID правила: {id}',
  'kb.cat.vulnerability': 'Уязвимость',
  'kb.cat.code_smell': 'Запах кода',
  'kb.cat.maintainability': 'Сопровождение',
  'kb.cat.security': 'Безопасность',
  'kb.cat.performance_issue': 'Нагрузка',
  'kb.cat.accessibility': 'Доступность',
  'kb.entryLoading': 'Загрузка записи…',
  'kb.entryFailed': 'Не удалось загрузить запись',
  'kb.back': 'К базе знаний',
  'kb.source': 'Источник',
  'kb.description': 'Описание',
  'kb.impact': 'Чем грозит',
  'kb.remediation': 'Как закрыть',
  'kb.cwe': 'CWE',
  'kb.references': 'Ссылки',
  'kb.tagsHeading': 'Метки',
  'kb.confidence': 'Уверенность',
  'kb.entryNotFound': 'Запись не найдена',

  'packs.notFound': 'Пакет не найден',
  'packs.createFailed': 'Не удалось создать пакет',
  'packs.canActivate': 'можно включить',
  'packs.membersCount': 'правил',
  'packs.nonActive': 'неактивных',

  'life.draft': 'черновик',
  'life.testing': 'тест',
  'life.approved': 'одобрен',
  'life.active': 'активен',
  'life.deprecated': 'устарел',
  'life.rejected': 'отклонён',
  'life.all': 'Все статусы',

  'val.pending': 'ждёт',
  'val.pass': 'ок',
  'val.fail': 'провал',
  'val.skipped': 'пропуск',

  'fmt.source': 'исходники',
  'fmt.dockerfile': 'Dockerfile',
  'fmt.kubernetes': 'Kubernetes',
  'fmt.terraform': 'Terraform',
  'fmt.ansible': 'Ansible',
  'fmt.compose': 'Compose',
  'fmt.helm': 'Helm',

  'tag.all': 'Все группы',
  'tag.CORE': 'ядро',
  'tag.WEB': 'веб',
  'tag.API': 'API',
  'tag.AUTH': 'вход',
  'tag.IAC': 'инфра-как-код',
  'tag.CLOUD': 'облако',
  'tag.LANGUAGE': 'язык',
  'tag.AI': 'ИИ',
  'tag.HMVM_META': 'HMVM',
  'tag.DATA': 'данные',
  'tag.BUSINESS_LOGIC': 'бизнес-логика',
  'tag.SUPPLY_CHAIN': 'поставка',
  'tag.DEVOPS': 'devops',
  'tag.FRAMEWORK': 'фреймворк',
  'tag.RELIABILITY': 'надёжность',
  'tag.PRIVACY': 'приватность',
  'tag.ARCHITECTURE': 'архитектура',
  'tag.performance': 'нагрузка',
  'tag.security': 'безопасность',
  'tag.critical': 'критично',
  'tag.php': 'PHP',
  'tag.python': 'Python',
  'tag.javascript': 'JavaScript',
  'tag.typescript': 'TypeScript',
  'tag.frontend': 'фронтенд',
  'tag.graphql': 'GraphQL',
  'tag.azure': 'Azure',
  'tag.cache': 'кэш',
  'tag.queue': 'очереди',
  'tag.memory': 'память',
  'tag.regex': 'regex',
  'tag.dotnet': '.NET',
  'tag.java': 'Java',
  'tag.go': 'Go',
  'tag.grpc': 'gRPC',
  'tag.websocket': 'WebSocket',

  'act.validate': 'Проверить',
  'act.submit_testing': 'В тест',
  'act.approve': 'Одобрить',
  'act.reject': 'Отклонить',
  'act.revise': 'Вернуть на правку',
  'act.activate': 'Включить',
  'act.deprecate': 'Снять',
  'act.confirm': 'Подтвердить',
  'act.reason': 'Причина',

  'proj.add': 'Добавить проект',
  'proj.create': 'Создать проект',
  'proj.displayName': 'Название',
  'proj.description': 'Заметка (необязательно)',
  'proj.gitUrl': 'HTTPS-ссылка на репозиторий',
  'proj.gitRef': 'Ветка / тег (необязательно)',
  'proj.zip': 'ZIP-архив',
  'proj.stagingUrl': 'URL стенда (только метаданные)',
  'proj.git': 'Git',
  'proj.zipBtn': 'ZIP',
  'proj.staging': 'Стенд',

  'reports.htmlCard': 'HTML-отчёт',
  'reports.pdfCard': 'PDF-отчёт',
  'reports.jsonCard': 'JSON-выгрузка',
  'reports.createdAt': 'Создан',
  'reports.generatedAt': 'Собран',
  'reports.size': 'Размер',
  'reports.downloadAria': 'Скачать {label}',
  'reports.refreshAria': 'Обновить статус отчёта',

  'audit.loading': 'Загрузка проверки…',
  'audit.viewFindings': 'К находкам →',
  'audit.viewCritical': 'К критичным →',
  'audit.viewHigh': 'К высоким →',
  'audit.viewMediumLow': 'К средним/низким →',
  'audit.mediumLowLabel': 'Средние + низкие',
  'audit.scoresTitle': 'Оценки проверки',
  'audit.riskScore': 'Риск',
  'audit.debtScore': 'Долг',
  'audit.complianceScore': 'Соответствие',
  'audit.timelineTitle': 'Ход проверки',
  'audit.config': 'Настройки',
  'audit.requestedTracks': 'Заказанные треки',
  'audit.executedTracks': 'Выполненные треки',
  'audit.quickScan': 'Быстрый скан',
  'audit.yes': 'да',
  'audit.no': 'нет',
  'audit.packsUsed': 'Пакеты правил',
  'audit.meta': 'Проверка',
  'audit.progress': 'Прогресс',
  'audit.tasksOf': '{done} из {total} задач',
  'audit.runningCount': '{n} идут',
  'audit.failedCount': '{n} с ошибкой',
  'audit.pendingCount': '{n} ждут',
  'audit.eta': 'оценка конца {time}',
  'audit.live': 'идёт сейчас',
  'audit.tasksEmpty': 'Задачи ещё не созданы',
  'audit.tasksEmptyBody': 'Как только воркер возьмёт проверку, здесь появятся треки.',
  'audit.timelineEmpty': 'Событий пока нет',
  'audit.findingsCount': '{n} находок',
  'audit.taskType': 'тип',
  'audit.aiAnalysis': 'ИИ-разбор',
  'audit.enabled': 'вкл',
  'audit.disabled': 'выкл',
  'audit.actions': 'Действия',
  'audit.actionFindings': 'Находки',
  'audit.actionEvidence': 'Доказательства',
  'audit.actionScores': 'Оценки',
  'audit.actionReports': 'Отчёты',
  'audit.actionFix': 'Исправить с ИИ',
  'audit.actionReaudit': 'Ещё раз',
  'audit.viewScoresDetail': 'Подробные оценки →',
  'audit.none': '—',
  'audit.timeout': 'Таймаут',
  'audit.maxFindings': 'Лимит находок на трек',

  'common.pageOf': 'Страница {page} из {total}',
  'common.pageAria': 'Страница {page}',
  'common.previous': 'Назад',
  'common.next': 'Дальше',

  'scores.title': 'Оценки',
  'scores.auditTitle': 'Оценки проверки',
  'scores.loading': 'Загрузка оценок…',
  'scores.failed': 'Не удалось загрузить оценки',
  'scores.indexLead': 'Риск, долг и покрытие по завершённым проверкам.',
  'scores.noneYet': 'Оценок ещё нет',
  'scores.noneYetBody': 'Оценки появляются, когда проверка закончилась. Запустите проверку и вернитесь сюда.',
  'scores.goAudits': 'К проверкам',
  'scores.riskDebtCompliance': 'Риск {risk} · Долг {debt} · Соответствие {compliance}',
  'scores.cannotScore': 'Эту проверку ещё нельзя оценить. Оценки есть только у завершённых и частично завершённых прогонов.',
  'scores.notFound': 'Проверка не найдена',
  'scores.backDash': '← К обзору',
  'scores.noData': 'Нет данных для оценки',
  'scores.backAudit': '← К проверке',
  'scores.notEvaluatedTitle': 'Не посчитано',
  'scores.noFindingsExplain': 'Находок нет, поэтому риск и долг не считаются. Соответствие смотрит только покрытие треков.',
  'scores.risk': 'Риск',
  'scores.debt': 'Технический долг',
  'scores.compliance': 'Соответствие',
  'scores.riskExplain': 'Риск по серьёзности и уверенности находок.',
  'scores.debtExplain': 'Качество кода, которое придётся чинить позже.',
  'scores.complianceExplain': 'Покрытие треков минус штраф за критичные находки.',
  'scores.howRisk': 'Как считается риск',
  'scores.howDebt': 'Как считается долг',
  'scores.howCompliance': 'Как считается соответствие',
  'scores.clickExpand': 'Открыть расчёт',
  'scores.clickCollapse': 'Свернуть',
  'scores.weightedSum': 'Взвешенная сумма',
  'scores.confAdj': 'Поправка на уверенность',
  'scores.normFactor': 'Нормировка',
  'scores.finalScore': 'Итог (0–100, верхняя граница)',
  'scores.contribTracks': 'Какие треки дали вклад:',
  'scores.severityDist': 'Распределение серьёзности',
  'scores.totalFindings': 'Всего: {n} находок',
  'scores.findingsWord': 'находок',
  'scores.noFindingsRecorded': 'Находок нет',
  'scores.viewSeverityAria': 'Показать {count} находок: {label}',
  'scores.trackCoverage': 'Покрытие треков',
  'scores.coverage': 'Покрытие',
  'scores.tracksExecutedOf': '{done} из {total} треков выполнено',
  'scores.executedTracks': 'Выполненные треки:',
  'scores.noTracksExecuted': 'Треки не выполнялись',
  'scores.requestedNotExecuted': 'Запрошены, но не выполнены:',
  'scores.viewAllFindings': 'Все находки',
  'scores.generateReport': 'Собрать отчёт',
  'scores.grade.excellent': 'Отлично',
  'scores.grade.good': 'Хорошо',
  'scores.grade.acceptable': 'Норма',
  'scores.grade.poor': 'Слабо',
  'scores.grade.critical': 'Критично',
  'scores.grade.high': 'Высоко',
  'scores.grade.medium': 'Средне',
  'scores.grade.low': 'Низко',
  'scores.grade.minimal': 'Минимум',
  'scores.notEvaluated': 'Не посчитано',
  'scores.ariaValue': '{label}: {score} из 100, {grade}',
  'scores.ariaNotEvaluated': '{label}: не посчитано',
  'scores.ariaScoreValue': 'Значение: {score}',
  'scores.severityCritical': 'критично',
  'scores.severityHigh': 'высоко',
  'scores.severityMedium': 'средне',
  'scores.severityLow': 'низко',
  'scores.severityInfo': 'справка',
  'fix.title': 'Исправить с ИИ',
  'fix.lead': 'Предлагаем правку отдельной веткой. В защищённые ветки ничего не пишем сами.',
  'fix.loading': 'Загрузка «Исправить с ИИ»…',
  'fix.failed': 'Не удалось загрузить «Исправить с ИИ»',
  'fix.orchOk': 'Оркестратор ИИ настроен. Запросы уходят только как предложение.',
  'fix.orchOff': 'ИИ недоступен: оркестратор не настроен. Находки и прошлые прогоны всё равно можно смотреть.',
  'fix.empty': 'Открытых находок нет',
  'fix.emptyBody': 'Сначала прогоните проверку, потом запросите предложение правки.',
  'fix.requestTitle': 'Запросить предложение правки',
  'fix.finding': 'Находка',
  'fix.branch': 'Ветка с правкой',
  'fix.baseRef': 'Базовая ветка',
  'fix.requesting': 'Отправляем…',
  'fix.request': 'Запросить предложение',
  'fix.recent': 'Недавние правки',
  'fix.none': 'Прогонов правок ещё нет.',
  'fix.selectFinding': 'Выберите находку',
  'fix.created': 'Прогон {id} создан, статус {status}. Правки предлагаются веткой — в защищённые ветки ничего не попадает.',
  'fix.openFindings': 'Открытые находки',
  'fix.appliedFailed': 'применено {applied} / ошибок {failed}',
  'reaudit.title': 'Повторная проверка',
  'reaudit.lead': 'Новая проверка с теми же пакетами, что были в исходном прогоне.',
  'reaudit.loading': 'Загрузка повторных проверок…',
  'reaudit.failed': 'Не удалось загрузить повторные проверки',
  'reaudit.empty': 'Завершённых проверок нет',
  'reaudit.emptyBody': 'Сначала доведите проверку до конца, потом запустите повтор.',
  'reaudit.startFrom': 'Стартовать из существующего прогона',
  'reaudit.original': 'Исходная проверка',
  'reaudit.quick': 'Быстрый скан',
  'reaudit.starting': 'Запускаем…',
  'reaudit.start': 'Запустить повтор',
  'reaudit.history': 'История повторов',
  'reaudit.none': 'Повторов ещё нет.',
  'reaudit.selectAudit': 'Выберите исходную проверку',
  'reaudit.new': 'новый {id}',
  'reaudit.from': 'из {id}',
  'reaudit.score': 'оценка {n}',
  'evidence.title': 'Доказательства',
  'evidence.loading': 'Загрузка доказательств…',
  'evidence.failed': 'Не удалось загрузить доказательства',
  'evidence.count': '{n} доказательств, связанных с находками',
  'evidence.countOne': '1 доказательство, связанное с находкой',
  'evidence.searchPh': 'Поиск по файлу, фрагменту или находке…',
  'evidence.searchAria': 'Поиск доказательств',
  'evidence.empty': 'Доказательств ещё нет',
  'evidence.emptyBody': 'После проверки здесь появляются файлы и фрагменты кода. Если находки уже есть — откройте находку: место в файле видно там.',
  'ev.file_line': 'строка файла',
  'ev.command_output': 'вывод команды',
  'ev.http_observation': 'HTTP-наблюдение',
  'ev.browser_observation': 'браузер',
  'ev.performance_metric': 'метрика',
  'ev.dependency_analysis': 'зависимость',
  'ev.secret_detection': 'секрет',
  'ev.static_analysis': 'статический разбор',
  'status.title': 'Статус системы',
  'status.lead': 'Живость бэкенда и готовность сервисов.',
  'status.health': 'Живость',
  'status.readiness': 'Готовность',
  'status.checking': 'Проверяем…',
  'status.ok': 'ОК',
  'status.failedBadge': 'Ошибка',
  'status.ready': 'Готово',
  'status.notReady': 'Не готово',
  'status.status': 'Статус',
  'status.version': 'Версия',
  'status.environment': 'Среда',
  'status.overallReady': 'Готовность в целом:',
  'status.yes': 'Да',
  'status.no': 'Нет',
  'status.componentChecks': 'Проверки компонентов',
  'status.apiEndpoints': 'API',
  'status.healthHint': 'Базовая живость',
  'status.readyHint': 'Готовность',
  'status.versionHint': 'Версия',
  'cmd.noResults': 'Ничего не найдено',
  'cmd.unavailable': 'Недоступно',
  'cmd.navigate': 'Навигация',
  'cmd.select': 'Выбрать',
  'reports.checkStatusAria': 'Проверить статус отчёта',
  'reports.building': 'Отчёт собирается…',
  'projects.add': 'Добавить проект',
  'projects.startAudit': 'Запустить проверку',
  'projects.searchPh': 'Поиск проектов…',
  'projects.shown': '{n} проектов · показано {shown}',
  'projects.clearFilters': 'Сбросить фильтры',
  'projects.noMatch': 'Нет проектов по фильтру',
  'audits.start': 'Запустить проверку',
  'audits.noMatch': 'Нет проверок по фильтру',
  'audits.tableAria': 'Таблица проверок',
  'audits.colProject': 'Проект',
  'audits.colCreated': 'Создано',
  'audits.colStatus': 'Статус',
  'audits.colFindings': 'Находки',
  'audits.colRisk': 'Риск',
  'audits.colDuration': 'Длительность',
  'audits.colActions': 'Действия',
  'audits.clearFilters': 'Сбросить фильтры',
  'settings.auditDefaults': 'Проверка по умолчанию',
  'settings.auditDefaultsBody': 'Только в этом браузере. Берётся при старте новой проверки.',
  'settings.defaultQuick': 'По умолчанию быстрый скан',
  'settings.defaultAi': 'По умолчанию включать ИИ-разбор',
  'settings.saved': 'Сохранено',
  'settings.kc': 'Управление знаниями',
  'settings.kcBody': 'Админ-токен живёт только во вкладке. После сохранения его больше не показывают.',
  'settings.tokenPresent': 'Токен для этой вкладки есть',
  'settings.clearToken': 'Убрать токен',
  'settings.pasteToken': 'Вставьте админ-токен',
  'settings.saveTab': 'Сохранить для вкладки',
  'settings.runtime': 'Среда',
  'settings.runtimeLoading': 'Загрузка среды…',
  'settings.runtimeFailed': 'Не удалось загрузить среду',
  'settings.product': 'Продукт',
  'settings.environment': 'Среда',
  'settings.fixAi': 'Исправить с ИИ',
  'settings.orchOn': 'Оркестратор настроен',
  'settings.orchOff': 'Недоступно — оркестратор не настроен',
  'settings.kcServer': 'Управление знаниями',
  'settings.kcOn': 'Админ-токен на сервере задан',
  'settings.kcOff': 'Админ-токен на сервере не задан',
  'settings.formats': 'Форматы отчётов',
  'dialog.failedLoad': 'Не удалось загрузить данные запуска',
  'dialog.failedStart': 'Не удалось запустить проверку',
  'dialog.failedCreate': 'Не удалось создать проект',
  'dialog.intakeNoProject': 'Загрузка не вернула проект',
  'theme.electric': 'Электрик',
  'theme.neutral': 'Нейтральный',

  'time.justNow': 'только что',
  'time.min': '{n} мин. назад',
  'time.hour': '{n} ч. назад',
  'time.day': '{n} дн. назад',
  'time.minutesAgo': '{n} мин. назад',
  'time.hoursAgo': '{n} ч. назад',
  'time.daysAgo': '{n} дн. назад',
  'time.minuteAgo': '1 минуту назад',
  'time.hourAgo': '1 час назад',
  'time.dayAgo': '1 день назад',

  'rel.same_rule': 'то же правило',
  'rel.same_fingerprint': 'тот же отпечаток',
  'rel.same_file': 'тот же файл',
  'cat.vulnerability': 'уязвимость',
  'cat.insecure_config': 'небезопасная конфигурация',
  'cat.misconfiguration': 'ошибка конфигурации',
  'cat.code_smell': 'запах кода',
  'tag.PATTERN': 'паттерн',
  'tag.AST': 'AST',
  'tag.SEMANTIC': 'семантика',
  'tag.session-security': 'сессии',

  'attention.failedTitle': '{project}: проверка сломалась',
  'attention.failedBody': 'Откройте прогон и посмотрите, на каком шаге упало.',
  'attention.criticalTitle': '{n} критичных в {project}',
  'attention.criticalBody': 'Это дыры, через которые можно украсть данные или выполнить свой код.',
  'attention.highTitle': '{n} высоких в {project}',
  'attention.highBody': 'Серьёзные слабости. Закройте после критичных.',
  'attention.otherTitle': 'Разберите {project}',
  'attention.otherBody': 'Найдено {n} пунктов.',
  'attention.open': 'Открыть',

  'projects.allSources': 'Все источники',
  'projects.allStatuses': 'Все статусы',
  'projects.filterSourceAria': 'Фильтр по источнику',
  'projects.filterStatusAria': 'Фильтр по статусу проверок',
  'projects.clearAria': 'Сбросить все фильтры',
  'projects.tableAria': 'Таблица проектов',
  'projects.colProject': 'Проект',
  'projects.colSource': 'Источник',
  'projects.colLastAudit': 'Последняя проверка',
  'projects.colAudits': 'Проверки',
  'projects.colStatus': 'Статус',
  'projects.colRisk': 'Риск',
  'projects.colActions': 'Действия',
  'projects.never': 'Никогда',
  'projects.rowAria': 'Проект {name}, {n} проверок, статус {status}',
  'projects.noneStatus': 'нет',

  'audits.searchPh': 'Поиск проверок…',
  'audits.searchAria': 'Поиск проверок',
  'audits.filterStatusAria': 'Фильтр по статусу',
  'audits.filterSeverityAria': 'Фильтр по серьёзности',
  'audits.allStatuses': 'Все статусы',
  'audits.allSeverities': 'Все уровни серьёзности',
  'audits.hasRisk': 'Есть риск (критично или высоко)',
  'audits.hasCritical': 'Есть критичные',
  'audits.hasHigh': 'Есть высокие',
  'audits.quickScan': 'Быстрый скан',
  'audits.tracksCount': '{n} треков',
  'audits.rowAria': 'Проверка {project}, статус {status}, {n} находок',
  'audits.summary': '{n} проверок · страница {page} из {total} · показано {shown}',
  'audits.prevAria': 'Предыдущая страница',
  'audits.nextAria': 'Следующая страница',

  'dash.postureCritical': 'Критичный риск: {n} критичных находок',
  'dash.postureHigh': 'Высокий риск: {n} высоких находок',
  'dash.postureLow': 'Низкий риск — критичных и высоких нет',
  'dash.failedLoadFallback': 'Не удалось загрузить обзор',

  'rec.criticalTitle': 'Разберите критичные находки',
  'rec.criticalBody': '{n} критичных пунктов требуют немедленного разбора',
  'rec.criticalAction': 'Критичные находки',
  'rec.criticalWhy': 'Критичные находки — прямой риск безопасности',
  'rec.failedTitle': 'Посмотрите упавшие проверки',
  'rec.failedBody': '{n} проверок не завершились',
  'rec.failedAction': 'К проверкам',
  'rec.failedWhy': 'Сбой проверки часто значит проблему инфраструктуры или конфига',
  'rec.highTitle': 'Разберите высокие находки',
  'rec.highBody': '{n} высоких находок',
  'rec.highAction': 'Высокие находки',
  'rec.highWhy': 'Высокие находки лучше закрыть сразу после критичных',
  'rec.runningTitle': 'Следите за идущими проверками',
  'rec.runningBody': '{n} проверок сейчас идут',
  'rec.runningAction': 'К проверкам',
  'rec.runningWhy': 'Проверки ещё не закончились',
  'rec.firstTitle': 'Запустите первую проверку',
  'rec.firstBody': 'Добавьте проект и прогоните первую проверку',
  'rec.firstAction': 'Добавить проект',
  'rec.firstWhy': 'Проверок ещё не было',
  'rec.mediumTitle': 'Разберите средние находки',
  'rec.mediumBody': '{n} средних находок',
  'rec.mediumAction': 'Средние находки',
  'rec.mediumWhy': 'Средние находки тоже стоит разобрать',
  'rec.allTitle': 'Разберите все находки',
  'rec.allBody': '{n} находок по всем уровням',
  'rec.allAction': 'Все находки',
  'rec.allWhy': 'Есть находки для разбора',

  'fixAi.title': 'Исправить с ИИ',
  'fixAi.aria': 'Исправить с ИИ — запросить предложение правки',
  'fixAi.startRun': 'Запустить прогон правки',
  'fixAi.startAria': 'Начать исправление с ИИ',
  'fixAi.creating': 'Создаём прогон правки…',
  'fixAi.whatHappens': 'Что произойдёт:',
  'fixAi.createBranch': 'Создадим ветку: {branch}',
  'fixAi.apply': 'Предложим правку для этой находки',
  'fixAi.tests': 'Прогоним тесты, если они есть',
  'fixAi.commit': 'Закоммитим в эту ветку',
  'fixAi.important': 'Важно:',
  'fixAi.noDeploy': 'ИИ не вливает правку в прод и не мержит сам. Только ветка — вы смотрите и решаете.',
  'fixAi.finding': 'Находка:',
  'fixAi.severity': 'Серьёзность:',
  'fixAi.strategy': 'Стратегия:',
  'fixAi.safest': '(только безопасные правки)',
  'fixAi.noContext': 'Нельзя создать прогон: нет контекста проверки',
  'fixAi.createFailed': 'Не удалось создать прогон правки',
  'fixAi.unknown': 'Неизвестная ошибка',
  'fixAi.errorTitle': 'Ошибка создания прогона',
  'fixAi.unavailable': 'Сервис ИИ сейчас недоступен.',
  'fixAi.unavailableHint': 'Это может быть временная настройка. Если не проходит — напишите администратору.',
  'fixAi.inProgress': '(идёт)',
  'fixAi.cancelRun': 'Отменить прогон',
  'fixAi.cancelling': 'Отменяем…',
  'fixAi.cancelFailed': 'Не удалось отменить',
  'fixAi.branchLabel': 'Ветка:',
  'fixAi.created': 'Создан:',
  'fixAi.started': 'Старт:',
  'fixAi.completed': 'Готово:',
  'fixAi.results': 'Результат:',
  'fixAi.fixesApplied': 'Правок применено:',
  'fixAi.failedCount': 'Не вышло:',
  'fixAi.finalCommit': 'Коммит:',
  'fixAi.statusAria': 'Статус: {status}',
  'fixAi.backFinding': '← К находке',
  'fixAi.viewAudit': 'К проверке',
  'fixAi.done': 'Готово',

  'fixRuns.title': 'История правок',
  'fixRuns.failedLoad': 'Не удалось загрузить прогоны правок',
  'fixRuns.batchFailed': 'Пакетная отмена не удалась',
  'fixRuns.noAudit': 'Проверка не выбрана',
  'fixRuns.noAuditBody': 'Выберите проверку, чтобы увидеть историю правок.',
  'fixRuns.errorTitle': 'Ошибка загрузки прогонов',
  'fixRuns.auditMeta': 'Проверка: {id}… · {n} прогонов',
  'fixRuns.backAudit': '← К проверке',
  'fixRuns.search': 'Поиск',
  'fixRuns.searchPh': 'Ветка, SHA коммита…',
  'fixRuns.status': 'Статус',
  'fixRuns.clearAll': 'Сбросить',
  'fixRuns.selectedOne': '{n} прогон выбран',
  'fixRuns.selectedMany': '{n} прогонов выбрано',
  'fixRuns.cancelSelected': 'Отменить выбранные',
  'fixRuns.batchComplete': 'Пакетная отмена завершена',
  'fixRuns.cancelled': 'Отменено: {n}',
  'fixRuns.skipped': 'Пропущено: {n} ({reasons})',
  'fixRuns.errors': 'Ошибки: {n}',
  'fixRuns.dismiss': 'Скрыть',
  'fixRuns.noneMatch': 'Нет подходящих прогонов',
  'fixRuns.noneYet': 'Прогонов правок ещё нет',
  'fixRuns.noneMatchBody': 'Смените фильтр.',
  'fixRuns.noneYetBody': 'Прогоны появятся после запроса правки.',
  'fixRuns.tableAria': 'История правок',
  'fixRuns.selectAllAria': 'Выбрать все отменяемые прогоны',
  'fixRuns.colId': 'ID',
  'fixRuns.colStatus': 'Статус',
  'fixRuns.colBranch': 'Ветка',
  'fixRuns.colBase': 'База',
  'fixRuns.colApplied': 'Применено',
  'fixRuns.colFailed': 'Сбой',
  'fixRuns.colCreated': 'Создано',
  'fixRuns.colCompleted': 'Готово',
  'fixRuns.showing': 'Показано {shown} из {total}',
  'fixRuns.nextPage': 'Дальше →',
  'fixRuns.confirmTitle': 'Отменить выбранные прогоны?',
  'fixRuns.confirmLead': 'Вы отмените',
  'fixRuns.confirmOne': 'прогон',
  'fixRuns.confirmMany': 'прогонов',
  'fixRuns.confirmNote': 'Это нельзя отменить обратно.',
  'fixRuns.confirmHint': 'Отменятся только ожидающие и идущие. Завершённые пропустят.',
  'fixRuns.confirmCancel': 'Отменить прогоны',
  'fixRuns.auditNotFound': 'Audit not found',
  'fixRuns.notFound': 'Прогон не найден',
  'fixRuns.detailTitle': 'Прогон правки',
  'fixRuns.applied': 'Правок применено',
  'fixRuns.failedFixes': 'Правок не вышло',
  'fixRuns.execDetails': 'Детали выполнения',
  'fixRuns.baseRef': 'Базовая ветка',
  'fixRuns.backHistory': '← К истории',
  'fixRuns.nextSteps': 'Правки остаются в ветке. Сначала смотрите ветку, потом мерж. В защищённые ветки сами ничего не пишем.',
  'fixRuns.errorDetail': 'Ошибка загрузки прогона',

  'audit.viewAllAria': 'Все находки этой проверки',
  'audit.viewCriticalAria': 'Критичные находки этой проверки',
  'audit.viewHighAria': 'Высокие находки этой проверки',
  'audit.viewMediumLowAria': 'Средние и низкие находки этой проверки',

  'cmd.aria': 'Быстрый переход',
  'modal.closeAria': 'Закрыть окно',
  'code.copyAria': 'Копировать код',
  'empty.generic': 'Что-то сломалось',
  'empty.retry': 'Попробовать снова',
  'common.loadingDots': 'Загрузка…',
  'common.copy': 'Копировать',
  'common.copied': 'Скопировано',

  'preflight.notFound': 'Предполёт не найден',
  'preflight.title': 'Предполётный разбор',
  'preflight.scannerVersion': 'Версия сканера',
  'preflight.projectId': 'ID проекта',
  'preflight.sourceId': 'ID источника',
  'preflight.stats': 'Статистика скана',
  'preflight.totalFiles': 'Всего файлов',
  'preflight.tech': 'Найденные технологии ({n})',
  'preflight.risky': 'Рискованные артефакты ({n})',
  'preflight.secrets': 'Признаки секретов ({n})',
  'preflight.commands': 'Объявленные команды ({n})',
  'preflight.failed': 'Не удалось загрузить предполёт',
  'preflight.loading': 'Загрузка предполёта…',
  'preflight.notFoundBody': 'Такого предполёта нет.',
  'preflight.decision': 'Решение',
  'preflight.safe': 'Можно продолжать',
  'preflight.blocked': 'Заблокировано',
  'preflight.reasons': 'Причины:',
  'preflight.blockers': 'Блокеры:',
  'preflight.scanned': 'Просканировано',
  'preflight.skipped': 'Пропущено',
  'preflight.colName': 'Имя',
  'preflight.colCategory': 'Категория',
  'preflight.colVersion': 'Версия',
  'preflight.colConfidence': 'Уверенность',
  'preflight.andMore': '… и ещё {n}',
  'preflight.secretsHint': 'Секреты скрыты. Показаны только признаки и категории.',
  'preflight.line': 'Строка {n}',
  'preflight.commandsHint': 'Команды из package.json, Makefile и т.п. (не выполнялись)',
  'preflight.source': 'Источник: {file}',
  'preflight.riskyBadge': 'риск',
  'preflight.succeeded': 'успех',
  'preflight.succeededWarn': 'успех с предупреждениями',
  'preflight.blockedStatus': 'заблокировано',
  'preflight.failedStatus': 'ошибка',

  'kc.actionFailed': 'Действие не удалось',
  'kc.addMemberFailed': 'Не удалось добавить участника',
  'kc.removeMemberFailed': 'Не удалось убрать участника',
  'kc.updateFailed': 'Не удалось обновить пакет',
  'kc.versionFailed': 'Не удалось создать версию',
  'kc.resolveFailed': 'Не удалось разрешить конфликт',

  'filter.allSeverities': 'Все уровни серьёзности',
  'filter.allTracks': 'Все треки',
  'filter.codeQuality': 'Качество кода',
  'filter.businessLogic': 'Бизнес-логика',
  'filter.dependencies': 'Зависимости',
  'filter.performance': 'Производительность',
  'filter.infrastructure': 'Инфраструктура',
  'filter.allStatuses': 'Все статусы',
  'filter.investigating': 'Смотрим',
  'filter.falsePositive': 'Ложное',
  'filter.wontFix': 'Не чиним',
  'filter.searchFindings': 'Поиск находок…',
}

const en: Dict = {
  'nav.dashboard': 'Dashboard',
  'nav.projects': 'Projects',
  'nav.audits': 'Audit Runs',
  'nav.auditDetails': 'Audit Details',
  'nav.findings': 'Findings',
  'nav.findingDetails': 'Finding Details',
  'nav.evidence': 'Evidence',
  'nav.scores': 'Scores',
  'nav.reports': 'Reports',
  'nav.fixWithAi': 'Fix with AI',
  'nav.reAudit': 'Re-audit',
  'nav.knowledgeBase': 'Knowledge Base',
  'nav.knowledgeControl': 'Knowledge Control',
  'nav.knowledgePacks': 'Knowledge Packs',
  'nav.packControl': 'Pack Control',
  'nav.ruleControl': 'Rule Control',
  'nav.settings': 'Settings',

  'group.overview': 'Overview',
  'group.projectsAudits': 'Projects & Audits',
  'group.investigation': 'Investigation',
  'group.analysis': 'Analysis',
  'group.ai': 'AI & Automation',
  'group.knowledge': 'Knowledge',
  'group.admin': 'Admin',

  'status.completed': 'completed',
  'status.running': 'running',
  'status.pending': 'pending',
  'status.queued': 'queued',
  'status.failed': 'failed',
  'status.partial': 'partial',
  'status.cancelled': 'cancelled',
  'status.timeout': 'timeout',
  'status.open': 'open',
  'status.acknowledged': 'acknowledged',
  'status.resolved': 'resolved',
  'status.false_positive': 'false positive',
  'status.wont_fix': "won't fix",
  'status.duplicate': 'duplicate',
  'status.investigating': 'investigating',
  'status.generating': 'generating',
  'status.success': 'success',

  'severity.critical': 'critical',
  'severity.high': 'high',
  'severity.medium': 'medium',
  'severity.low': 'low',
  'severity.info': 'info',

  'track.code_quality': 'Code quality',
  'track.security': 'Security',
  'track.api': 'API',
  'track.infrastructure': 'Infrastructure',
  'track.business_logic': 'Business logic',
  'track.e2e_ui': 'UI / e2e',
  'track.performance': 'Performance',
  'track.ai_code_risk': 'AI code risk',

  'common.loading': 'Loading…',
  'common.error': 'Error',
  'common.back': 'Back',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.search': 'Search',
  'common.close': 'Close',
  'common.offline': 'Offline',
  'common.selectProject': 'Select Project',
  'common.theme': 'Toggle theme',
  'common.accent': 'Accent color',
  'common.signingIn': 'Signing in via HMVMAuth…',
  'common.generate': 'Generate',
  'common.download': 'Download',
  'common.refresh': 'Refresh',
  'common.create': 'Create',
  'common.start': 'Start',
  'common.retry': 'Retry',
  'common.expandSidebar': 'Expand sidebar',
  'common.collapseSidebar': 'Collapse sidebar',
  'common.breadcrumb': 'Breadcrumb',
  'common.sso': 'SSO / TG',
  'common.logout': 'Log out',
  'common.authHome': 'Single sign-on',
  'common.viewFindings': 'View findings',
  'common.total': 'Total',
  'common.version': 'version',

  'lang.ru': 'RUS',
  'lang.en': 'EN',
  'lang.switch': 'Interface language',

  'review.what': 'What this is',
  'review.why': 'Why it matters',
  'review.where': 'Where to look',
  'review.fix': 'Remediation',
  'review.snippet': 'Code snippet',
  'review.impact': 'If you leave it',
  'review.details': 'Details',
  'review.location': 'File',
  'review.reproduction': 'Reproduction Steps',
  'review.remediation': 'Remediation',
  'review.effort': 'Effort',
  'review.confidence': 'Confidence',
  'review.related': 'Related findings',

  'page.dashboard': 'Dashboard',
  'page.dashboardLead': 'Close critical holes first. Everything else can wait.',
  'page.projects': 'Projects',
  'page.projectsLead': 'Drop a git repo or a ZIP, then start an audit.',
  'page.audits': 'Audit runs',
  'page.auditsLead': 'Each run is a snapshot plus a finding list.',
  'page.findings': 'Findings',
  'page.findingsLead': 'Triage queue: critical first, then high.',
  'page.evidence': 'Evidence',
  'page.evidenceLead': 'The code that backs each finding.',
  'page.scores': 'Scores',
  'page.scoresLead': 'Risk, debt, and compliance for a run.',
  'page.reports': 'Reports',
  'page.reportsLead': 'A technical review a person can actually read.',
  'page.settings': 'Settings',
  'page.settingsLead': 'Theme and scan defaults. Language is RUS | EN in the top-right.',
  'page.fixAi': 'Fix with AI',
  'page.reAudit': 'Re-audit',
  'page.knowledgeBase': 'Knowledge Base',
  'page.knowledgeControl': 'Knowledge Control',
  'page.knowledgePacks': 'Knowledge Packs',

  'dash.risk': 'Risk now',
  'dash.attention': 'Needs attention',
  'dash.recommended': 'Next step',
  'dash.recent': 'Recent audits',
  'dash.firstTitle': 'Nothing here yet',
  'dash.firstBody': 'Create a project and start the first audit. The report will land here.',
  'dash.startAudit': 'Start audit',
  'dash.newProject': 'New project',
  'dash.failedLoad': 'Failed to load dashboard',
  'dash.viewCritical': 'Critical',
  'dash.viewHigh': 'High',

  'audit.totalFindings': 'Total findings',
  'audit.critical': 'Critical',
  'audit.high': 'High',
  'audit.mediumLow': 'Medium + low',
  'audit.tasks': 'Tasks',
  'audit.timeline': 'Timeline',
  'audit.scores': 'Scores',
  'audit.openReports': 'Report',
  'audit.run': 'Audit',

  'findings.empty': 'No findings',
  'findings.emptyHint': 'Change the filter or wait for the run to finish.',
  'findings.filters': 'Filters',
  'findings.advanced': 'More filters',
  'findings.title': 'Title',
  'findings.severity': 'Severity',
  'findings.status': 'Status',
  'findings.project': 'Project',
  'findings.failedLoad': 'Failed to load findings',

  'dialog.startTitle': 'New audit',
  'dialog.startLead': 'Pick a project and the tracks to run. AI is optional.',
  'dialog.selectProjectFirst': 'Select a project first',
  'dialog.selectTrack': 'Select at least one audit track',
  'dialog.tracks': 'Tracks',
  'dialog.packs': 'Rule packs (optional)',
  'dialog.quickScan': 'Quick scan',
  'dialog.includeAi': 'AI analysis',
  'dialog.createTitle': 'New project',
  'dialog.nameRequired': 'Display name is required',
  'dialog.repoRequired': 'Repository URL is required',
  'dialog.zipRequired': 'Choose a ZIP file',
  'dialog.stagingRequired': 'Staging URL is required',
  'dialog.displayName': 'Name',
  'dialog.description': 'Note',
  'dialog.git': 'Git',
  'dialog.zip': 'ZIP',
  'dialog.staging': 'Staging',
  'dialog.repoUrl': 'Repository URL',
  'dialog.gitRef': 'Branch / tag',
  'dialog.stagingUrl': 'Staging URL',

  'reports.recent': 'Recent reports',
  'reports.pickRun': 'Pick an audit',
  'reports.none': 'No reports yet',
  'reports.failedLoad': 'Failed to load reports',
  'reports.failedGenerate': 'Failed to generate report',
  'reports.technical': 'Technical review',

  'settings.themeBase': 'Light / dark',
  'settings.themeAccent': 'Accent color',
  'settings.appearance': 'Appearance',
  'settings.lead': 'Local display preferences and operator configuration. Secrets are never shown.',
  'settings.projects': 'Projects',
  'settings.projectsLead': 'Delete an uploaded project together with its runs, findings, and reports. This cannot be undone.',
  'settings.noProjects': 'No projects',
  'settings.runs': 'Runs',
  'settings.deleteProject': 'Delete project',
  'settings.deleteRun': 'Delete run',
  'settings.confirmProjectTitle': 'Delete project',
  'settings.confirmProjectBody': 'All runs, findings, evidence, and reports for this project will be removed. Type the project name to confirm.',
  'settings.confirmName': 'Project name',
  'settings.confirmRunTitle': 'Delete run',
  'settings.confirmRunBody': 'This run, its findings, and reports will be removed. The project stays.',
  'settings.deleteForever': 'Delete forever',
  'settings.deleted': 'Deleted',
  'settings.auditsCount': 'runs',
  'settings.themeDark': 'Dark',
  'settings.themeLight': 'Light',
  'settings.themeSystem': 'System',

  'dash.title': 'Security Dashboard',
  'dash.loading': 'Loading dashboard data...',
  'dash.loadFailed': 'Dashboard Load Failed',
  'dash.welcome': 'Welcome to HMVMReviewer. No audits have been run yet. Add a project and start your first security audit to see risk insights here.',
  'dash.startFirst': 'Start First Audit',
  'dash.addProject': 'Add project',
  'dash.startAuditBtn': 'Start audit',
  'dash.lead': 'Risk posture, critical findings, and recommended actions',
  'dash.overallRisk': 'Overall Risk',
  'dash.critHigh': 'Critical & High Priority',
  'dash.auditHealth': 'Audit Health',
  'dash.requiresAttention': 'Requires Attention',
  'dash.distribution': 'Finding Distribution',
  'dash.recentActivity': 'Recent Activity',
  'dash.noAttention': 'No critical or high-priority items',
  'dash.legendCritical': 'Critical',
  'dash.legendHigh': 'High',
  'dash.legendMedium': 'Medium',
  'dash.legendLow': 'Low',
  'dash.legendInfo': 'Info',
  'dash.totalFindingsKpi': 'Total Findings',
  'dash.acrossAudits': 'Current snapshot (latest run per project)',
  'dash.clickView': 'Click to view →',
  'dash.viewAll': 'View All →',
  'dash.recommendedBadge': 'RECOMMENDED',
  'dash.noFindingsDisplay': 'No findings to display',
  'dash.noRecent': 'No recent audits',
  'dash.findingOne': 'finding',
  'dash.findingsMany': 'findings',
  'dash.noData': 'No Dashboard Data',
  'dash.noDataBody': 'Unable to load dashboard statistics.',
  'dash.critShort': 'CRIT',
  'dash.highShort': 'HIGH',
  'dash.projectsShort': 'PROJECTS',
  'dash.doneShort': 'DONE',
  'dash.runningShort': 'RUNNING',
  'dash.failedShort': 'FAILED',
  'dash.viewCritHigh': 'View critical and high priority findings',
  'dash.viewAllFindings': 'View all findings',
  'dash.viewAllAudits': 'View all audits',
  'dash.attentionAria': 'Items Requiring Attention',
  'dash.riskAria': 'Risk Posture Summary',
  'dash.distAria': 'Severity Distribution',
  'dash.recentAria': 'Recent Audits',
  'dash.recAria': 'Recommended Action',

  'finding.loading': 'Loading finding details...',
  'finding.error': 'Error Loading Finding',
  'finding.backAria': 'Back to findings list',
  'finding.evidence': 'Evidence',
  'finding.noEvidence': 'No Evidence Available',
  'finding.noEvidenceBody': 'This finding does not have associated evidence, or evidence has been destroyed per data lifecycle policy.',
  'finding.primary': 'Primary',
  'finding.destroyed': 'Evidence content unavailable or destroyed per data lifecycle policy',
  'finding.stored': 'Evidence stored externally',
  'finding.ruleProvenance': 'Rule Provenance',
  'finding.ruleId': 'Rule ID',
  'finding.source': 'Source',
  'finding.viewKb': 'View in Knowledge Base',
  'finding.auditContext': 'Audit Context',
  'finding.related': 'Related Findings',
  'finding.viewAllRelated': 'View All Related',
  'finding.loadingRelated': 'Loading related findings...',
  'finding.project': 'Project',
  'finding.auditRun': 'Audit Run',
  'finding.tracks': 'Tracks',
  'finding.completed': 'Completed',
  'finding.securityIds': 'Security IDs',
  'finding.tags': 'Tags',
  'finding.timestamps': 'Timestamps',
  'finding.created': 'Created',
  'finding.firstSeen': 'First Seen',
  'finding.lastSeen': 'Last Seen',
  'finding.script': 'Reproduction Script',
  'finding.audit': 'Audit',

  'findings.loading': 'Loading findings...',
  'findings.count': '{n} findings in current snapshot',
  'findings.countAll': '{n} findings across all runs',
  'findings.searchPh': 'Search title, description, location...',
  'findings.allStatuses': 'All Statuses',
  'findings.allConfidence': 'All Confidence',
  'findings.showAdvanced': 'Show Advanced',
  'findings.hideAdvanced': 'Hide Advanced',
  'findings.clearAll': 'Clear All',
  'findings.noMatching': 'No Matching Findings',
  'findings.noMatchingBody': 'No findings match your current filters. Try adjusting or clearing filters.',
  'findings.emptyTitle': 'No Findings',
  'findings.emptyBody': 'No findings have been recorded yet. Run an audit to generate findings.',
  'findings.tableAria': 'Findings table',
  'findings.colTrack': 'Track',
  'findings.colLocation': 'Location',
  'findings.colCreated': 'Created',
  'findings.searchAria': 'Search findings',
  'findings.statusAria': 'Filter by status',
  'findings.confidenceAria': 'Filter by confidence',
  'findings.clearAria': 'Clear all filters',
  'findings.filtered': '(filtered)',
  'findings.category': 'Category',
  'findings.projectId': 'Project ID',
  'findings.auditId': 'Audit Run ID',
  'findings.filterSeverityAria': 'Filter {severity} severity findings',
  'findings.filterTrackAria': 'Filter by track',
  'findings.filterCategoryAria': 'Filter by category',
  'findings.filterProjectAria': 'Filter by project ID',
  'findings.filterAuditAria': 'Filter by audit run ID',
  'findings.trackPh': 'e.g., sast, api_security',
  'findings.categoryPh': 'e.g., vulnerability',
  'findings.uuidPh': 'UUID',
  'findings.summarySeverities': '{n} severities',
  'findings.summaryStatus': 'Status: {v}',
  'findings.summaryConfidence': 'Confidence: {v}',
  'findings.summaryTrack': 'Track: {v}',
  'findings.summaryCategory': 'Category: {v}',
  'findings.summarySearch': 'Search: "{v}"',
  'findings.rowAria': 'Finding: {title}, Severity: {severity}, Status: {status}',
  'conf.high': 'high',
  'conf.medium': 'medium',
  'conf.low': 'low',
  'conf.uncertain': 'uncertain',

  'reports.title': 'Reports',
  'reports.auditTitle': 'Audit Reports',
  'reports.loading': 'Loading reports...',
  'reports.indexLead': 'Open or generate HTML, PDF, and JSON exports for completed audit runs.',
  'reports.generateNew': 'Generate New Report',
  'reports.generateLead': 'HTML for engineers (expandable findings). PDF for business (overview, no code). JSON export.',
  'reports.generateHtml': 'HTML — engineer',
  'reports.generatePdf': 'PDF — business',
  'reports.generateJson': 'JSON — export',
  'reports.generating': 'Generating...',
  'reports.notAvailable': 'Report Generation Not Available',
  'reports.notAvailableBody': 'Reports can only be generated for audits that have reached a terminal state (completed, partial, or failed). This audit is currently {status}.',
  'reports.generated': 'Generated Reports',
  'reports.noneYet': 'No reports generated yet. Generate your first report above.',
  'reports.backAudit': '← Back to Audit',
  'reports.backDash': '← Back to Dashboard',
  'reports.htmlHint': 'HTML and JSON are ready quickly. PDF takes longer and has no code snippets.',
  'findings.scopeCurrent': 'Current snapshot',
  'findings.scopeAll': 'All runs',
  'findings.scopeAria': 'Findings scope',
  'findings.triage': 'Status',
  'findings.triageAria': 'Change finding status',
  'findings.triageSaved': 'Status updated',
  'findings.triageFailed': 'Failed to update status',
  'findings.filterTrack': 'Track',
  'findings.filterCategory': 'Category',
  'findings.filterProject': 'Project ID',
  'findings.filterAudit': 'Audit run ID',
  'findings.severitiesN': '{n} severities',
  'findings.activeStatus': 'Status: {v}',
  'findings.activeConfidence': 'Confidence: {v}',
  'findings.activeTrack': 'Track: {v}',
  'findings.activeCategory': 'Category: {v}',
  'findings.activeSearch': 'Search: "{v}"',
  'findings.openQueue': 'Open',
  'settings.clearTokenConfirm': 'Clear the admin token from this tab?',
  'reports.fromAudit': 'Generate from an audit',
  'reports.findingsDot': '{n} findings · {when}',
  'reports.goAudits': 'Go to Audit Runs',
  'reports.noneIndex': 'No reports yet',
  'reports.noneIndexBody': 'Reports can be generated after an audit reaches a terminal state.',
  'reports.downloadFail': 'Failed to download report: {msg}',
  'reports.generateFail': 'Failed to generate report: {msg}',
  'reports.notFound': 'Report not found',

  'dialog.startTitleUi': 'Start audit',
  'dialog.starting': 'Starting…',
  'dialog.cancel': 'Cancel',
  'dialog.noProjects': 'Create a project before starting an audit.',
  'dialog.project': 'Project',
  'dialog.selectProject': 'Select project',
  'dialog.tracksLegend': 'Tracks',
  'dialog.packsLegend': 'Knowledge Packs (ACTIVE only)',
  'dialog.noActivePacks': 'No ACTIVE packs. The run will use all ACTIVE rules (legacy default).',
  'dialog.leavePacks': 'Leave unselected to use all ACTIVE rules.',
  'dialog.createTitleUi': 'New project',
  'dialog.creating': 'Creating…',

  'projects.loading': 'Loading projects...',
  'projects.failed': 'Failed to Load Projects',
  'projects.empty': 'No Projects Yet',
  'projects.emptyBody': 'Add a git repo, ZIP, or staging URL, then start an audit.',

  'audits.loading': 'Loading audit runs...',
  'audits.failed': 'Failed to Load Audit Runs',
  'audits.empty': 'No Audit Runs Yet',
  'audits.emptyBody': 'Start an audit from an existing project. Results and status will appear here.',
  'audits.back': 'Back to Audit Runs',

  'packs.lead': 'Versioned rule collections. Activation cannot bypass ACTIVE-only Knowledge Control.',
  'packs.editMeta': 'Edit metadata',
  'packs.saveMeta': 'Save metadata',
  'packs.members': 'Membership',
  'packs.addMember': 'Add member',
  'packs.removeMember': 'Remove',
  'packs.noMembers': 'No member rules',
  'packs.noMembersBody': 'Attach ACTIVE rules before validation can PASS.',
  'packs.memberId': 'Rule database UUID',
  'packs.newVersion': 'New version',
  'packs.copyDraft': 'Copy to DRAFT version',
  'packs.history': 'History',
  'packs.noHistory': 'No transitions yet.',
  'packs.previewResolve': 'Preview run resolution',
  'packs.confirmBody': 'This action is recorded in append-only pack history. Actor comes from the admin token, not the form.',
  'packs.colActive': 'Active',
  'packs.yes': 'yes',
  'packs.no': 'no',
  'packs.backControl': 'Back to Knowledge Control',
  'packs.total': 'total packs {n}',
  'packs.active': 'active packs {n}',
  'packs.search': 'Search packs...',
  'packs.statusAria': 'Pack lifecycle status',
  'packs.groupAria': 'Pack group tag',
  'packs.create': 'Create pack',
  'packs.clearToken': 'Clear token',
  'packs.loading': 'Loading Knowledge Packs...',
  'packs.failed': 'Failed to Load Knowledge Packs',
  'packs.empty': 'No packs in this queue',
  'packs.emptyFilter': 'Try adjusting your filters',
  'packs.emptyCreate': 'Create a DRAFT pack to get started',
  'packs.colPack': 'Pack',
  'packs.colStatus': 'Status',
  'packs.colValidation': 'Validation',
  'packs.colMembers': 'Members',
  'packs.colFormat': 'Format',
  'packs.colTags': 'Tags',
  'packs.prev': 'Previous',
  'packs.next': 'Next',
  'packs.page': 'Page {page} of {total} ({count})',
  'packs.createTitle': 'Create Knowledge Pack',
  'packs.creating': 'Creating…',
  'packs.createDraft': 'Create DRAFT pack',
  'packs.tokenLead': 'Admin authentication is required. Use the same Knowledge Control token.',
  'packs.tokenLabel': 'Admin token',
  'packs.authenticate': 'Authenticate',
  'packs.fieldPackId': 'pack_id',
  'packs.fieldVersion': 'version',
  'packs.fieldName': 'name',
  'packs.fieldFormat': 'format_type',
  'packs.fieldDescription': 'description',

  'kc.lead': 'Human approval queue. AI proposals cannot activate themselves.',
  'kc.matchSpec': 'Match spec',
  'kc.authRequired': 'Authentication required',
  'kc.tokenLead': 'Admin authentication is required. Paste the local Knowledge Control token. It is stored only in this browser tab and is never shipped in the frontend bundle.',
  'kc.tokenLabel': 'Admin token',
  'kc.authenticate': 'Authenticate',
  'kc.loading': 'Loading Knowledge Control...',
  'kc.failed': 'Failed to Load Knowledge Control',
  'kc.search': 'Search rules...',
  'kc.statusAria': 'Lifecycle status',
  'kc.empty': 'No rules in this queue',
  'kc.emptyFilter': 'Try adjusting your filters',
  'kc.emptyQueue': 'The Knowledge Control queue is empty',
  'kc.colRule': 'Rule',
  'kc.colRuleEn': 'Rule',
  'kc.colActions': 'Actions',
  'kc.statDraft': 'Draft',
  'kc.statTesting': 'Testing',
  'kc.statReady': 'Ready',
  'kc.statTotal': 'Total',
  'kc.statPacks': 'Packs',
  'kc.openPacks': 'Knowledge Packs',
  'kc.notFound': 'Rule not found',
  'kc.rationale': 'Proposal rationale',

  'kb.lead': 'Browse and search reusable security rules and remediation guidance. Only ACTIVE packs and ACTIVE rules are shown.',
  'kb.loading': 'Loading Knowledge Base...',
  'kb.failed': 'Failed to Load Knowledge Base',
  'kb.activePacks': 'Active packs',
  'kb.packLine': '{name} ({id}@{version}, {n} rules)',
  'kb.totalEntries': 'Total Entries',
  'kb.categories': 'Categories',
  'kb.formats': 'Formats',
  'kb.search': 'Search rules...',
  'kb.allSeverities': 'All Severities',
  'kb.allCategories': 'All Categories',
  'kb.allFormats': 'All Formats',
  'kb.clearFilters': 'Clear Filters',
  'kb.showing': 'Showing {shown} of {total} entries',
  'kb.emptyFilter': 'No Matching Entries',
  'kb.emptyTitle': 'No Entries Available',
  'kb.empty': 'The Knowledge Base is empty',
  'kb.hasFix': 'Has Remediation',
  'kb.ruleId': 'Rule ID: {id}',
  'kb.cat.vulnerability': 'Vulnerability',
  'kb.cat.code_smell': 'Code Smell',
  'kb.cat.maintainability': 'Maintainability',
  'kb.cat.security': 'Security',
  'kb.cat.performance_issue': 'Performance',
  'kb.cat.accessibility': 'Accessibility',
  'kb.entryLoading': 'Loading entry...',
  'kb.entryFailed': 'Failed to Load Entry',
  'kb.back': 'Back to Knowledge Base',
  'kb.source': 'Source',
  'kb.description': 'Description',
  'kb.impact': 'Impact',
  'kb.remediation': 'Remediation',
  'kb.cwe': 'CWE References',
  'kb.references': 'External References',
  'kb.tagsHeading': 'Tags',
  'kb.confidence': 'Confidence',
  'kb.entryNotFound': 'Entry not found',

  'packs.notFound': 'Pack not found',
  'packs.createFailed': 'Create failed',
  'packs.canActivate': 'can activate',
  'packs.membersCount': 'members',
  'packs.nonActive': 'non-active',

  'life.draft': 'Draft',
  'life.testing': 'Testing',
  'life.approved': 'Approved',
  'life.active': 'Active',
  'life.deprecated': 'Deprecated',
  'life.rejected': 'Rejected',
  'life.all': 'All statuses',

  'val.pending': 'pending',
  'val.pass': 'pass',
  'val.fail': 'fail',
  'val.skipped': 'skipped',

  'fmt.source': 'source',
  'fmt.dockerfile': 'Dockerfile',
  'fmt.kubernetes': 'Kubernetes',
  'fmt.terraform': 'Terraform',
  'fmt.ansible': 'Ansible',
  'fmt.compose': 'Compose',
  'fmt.helm': 'Helm',

  'tag.all': 'All groups',
  'tag.CORE': 'CORE',
  'tag.WEB': 'WEB',
  'tag.API': 'API',
  'tag.AUTH': 'AUTH',
  'tag.IAC': 'IAC',
  'tag.CLOUD': 'CLOUD',
  'tag.LANGUAGE': 'LANGUAGE',
  'tag.AI': 'AI',
  'tag.HMVM_META': 'HMVM_META',
  'tag.DATA': 'DATA',
  'tag.BUSINESS_LOGIC': 'BUSINESS_LOGIC',
  'tag.SUPPLY_CHAIN': 'SUPPLY_CHAIN',
  'tag.DEVOPS': 'DEVOPS',
  'tag.FRAMEWORK': 'FRAMEWORK',
  'tag.RELIABILITY': 'RELIABILITY',
  'tag.PRIVACY': 'PRIVACY',
  'tag.ARCHITECTURE': 'ARCHITECTURE',
  'tag.performance': 'performance',
  'tag.security': 'security',
  'tag.critical': 'critical',
  'tag.php': 'php',
  'tag.python': 'python',
  'tag.javascript': 'javascript',
  'tag.typescript': 'typescript',
  'tag.frontend': 'frontend',
  'tag.graphql': 'graphql',
  'tag.azure': 'azure',
  'tag.cache': 'cache',
  'tag.queue': 'queue',
  'tag.memory': 'memory',
  'tag.regex': 'regex',
  'tag.dotnet': 'dotnet',
  'tag.java': 'java',
  'tag.go': 'go',
  'tag.grpc': 'grpc',
  'tag.websocket': 'websocket',

  'act.validate': 'Validate',
  'act.submit_testing': 'Submit to testing',
  'act.approve': 'Approve',
  'act.reject': 'Reject',
  'act.revise': 'Request revision',
  'act.activate': 'Activate',
  'act.deprecate': 'Deprecate',
  'act.confirm': 'Confirm',
  'act.reason': 'Reason',

  'proj.add': 'Add project',
  'proj.create': 'Create project',
  'proj.displayName': 'Display name',
  'proj.description': 'Description (optional)',
  'proj.gitUrl': 'Public HTTPS repository URL',
  'proj.gitRef': 'Ref (optional)',
  'proj.zip': 'ZIP archive',
  'proj.stagingUrl': 'Staging URL (metadata only)',
  'proj.git': 'Git',
  'proj.zipBtn': 'ZIP',
  'proj.staging': 'Staging URL',

  'reports.htmlCard': 'HTML Report',
  'reports.pdfCard': 'PDF Report',
  'reports.jsonCard': 'JSON Export',
  'reports.createdAt': 'Created:',
  'reports.generatedAt': 'Generated:',
  'reports.size': 'Size:',
  'reports.downloadAria': 'Download {label}',
  'reports.refreshAria': 'Refresh report status',

  'audit.loading': 'Loading audit...',
  'audit.viewFindings': 'View findings →',
  'audit.viewCritical': 'View critical →',
  'audit.viewHigh': 'View high →',
  'audit.viewMediumLow': 'View medium/low →',
  'audit.mediumLowLabel': 'Medium + Low',
  'audit.scoresTitle': 'Audit Scores',
  'audit.riskScore': 'Risk Score',
  'audit.debtScore': 'Debt Score',
  'audit.complianceScore': 'Compliance Score',
  'audit.timelineTitle': 'Workflow Timeline',
  'audit.config': 'Configuration',
  'audit.requestedTracks': 'Requested Tracks',
  'audit.executedTracks': 'Executed Tracks',
  'audit.quickScan': 'Quick Scan',
  'audit.yes': 'Yes',
  'audit.no': 'No',
  'audit.packsUsed': 'Knowledge Packs',
  'audit.meta': 'Audit Run',
  'audit.progress': 'Progress',
  'audit.tasksOf': '{done}/{total} tasks',
  'audit.runningCount': '{n} running',
  'audit.failedCount': '{n} failed',
  'audit.pendingCount': '{n} pending',
  'audit.eta': 'ETA {time}',
  'audit.live': 'live',
  'audit.tasksEmpty': 'No tasks yet',
  'audit.tasksEmptyBody': 'Tracks will appear here as soon as the worker picks up the run.',
  'audit.timelineEmpty': 'No workflow events yet',
  'audit.findingsCount': '{n} findings',
  'audit.taskType': 'type',
  'audit.aiAnalysis': 'AI Analysis',
  'audit.enabled': 'Enabled',
  'audit.disabled': 'Disabled',
  'audit.actions': 'Actions',
  'audit.actionFindings': 'View Findings',
  'audit.actionEvidence': 'Evidence',
  'audit.actionScores': 'View Scores',
  'audit.actionReports': 'Reports',
  'audit.actionFix': 'Fix with AI',
  'audit.actionReaudit': 'Re-audit',
  'audit.viewScoresDetail': 'View Detailed Scores →',
  'audit.none': '—',
  'audit.timeout': 'Timeout',
  'audit.maxFindings': 'Max findings per track',

  'common.pageOf': 'Page {page} of {total}',
  'common.pageAria': 'Page {page}',
  'common.previous': 'Previous',
  'common.next': 'Next',

  'scores.title': 'Scores',
  'scores.auditTitle': 'Audit Scores',
  'scores.loading': 'Loading scores...',
  'scores.failed': 'Failed to load scores',
  'scores.indexLead': 'Aggregate risk, debt, and compliance scores from completed audit runs.',
  'scores.noneYet': 'No scored audits yet',
  'scores.noneYetBody': 'Scores appear after an audit completes. Start an audit, then return here.',
  'scores.goAudits': 'Go to Audit Runs',
  'scores.riskDebtCompliance': 'Risk {risk} · Debt {debt} · Compliance {compliance}',
  'scores.cannotScore': 'This audit cannot be scored yet. Scores are available for completed or partially completed audits only.',
  'scores.notFound': 'Audit run not found',
  'scores.backDash': '← Back to Dashboard',
  'scores.noData': 'No scoring data available',
  'scores.backAudit': '← Back to Audit',
  'scores.notEvaluatedTitle': 'Not Evaluated',
  'scores.noFindingsExplain': 'No findings were recorded for this audit, so risk and debt scores cannot be calculated. Compliance score is based on track coverage only.',
  'scores.risk': 'Risk Score',
  'scores.debt': 'Technical Debt Score',
  'scores.compliance': 'Compliance Score',
  'scores.riskExplain': 'Security and operational risk based on severity and confidence',
  'scores.debtExplain': 'Code quality issues requiring future attention',
  'scores.complianceExplain': 'Track coverage minus critical finding penalties',
  'scores.howRisk': 'How Risk Score is Calculated',
  'scores.howDebt': 'How Debt Score is Calculated',
  'scores.howCompliance': 'How Compliance Score is Calculated',
  'scores.clickExpand': 'Click to expand',
  'scores.clickCollapse': 'Click to collapse',
  'scores.weightedSum': 'Severity Weighted Sum',
  'scores.confAdj': 'Confidence Adjustment',
  'scores.normFactor': 'Normalization Factor',
  'scores.finalScore': 'Final Score (0-100, capped)',
  'scores.contribTracks': 'Contributing Tracks:',
  'scores.severityDist': 'Severity Distribution',
  'scores.totalFindings': 'Total: {n} findings',
  'scores.findingsWord': 'findings',
  'scores.noFindingsRecorded': 'No findings recorded',
  'scores.viewSeverityAria': 'View {count} {label} severity findings',
  'scores.trackCoverage': 'Track Coverage',
  'scores.coverage': 'Coverage',
  'scores.tracksExecutedOf': '{done} of {total} tracks executed',
  'scores.executedTracks': 'Executed Tracks:',
  'scores.noTracksExecuted': 'No tracks executed',
  'scores.requestedNotExecuted': 'Requested but not executed:',
  'scores.viewAllFindings': 'View All Findings',
  'scores.generateReport': 'Generate Report',
  'scores.grade.excellent': 'Excellent',
  'scores.grade.good': 'Good',
  'scores.grade.acceptable': 'Acceptable',
  'scores.grade.poor': 'Poor',
  'scores.grade.critical': 'Critical',
  'scores.grade.high': 'High',
  'scores.grade.medium': 'Medium',
  'scores.grade.low': 'Low',
  'scores.grade.minimal': 'Minimal',
  'scores.notEvaluated': 'Not evaluated',
  'scores.ariaValue': '{label}: {score} out of 100, {grade}',
  'scores.ariaNotEvaluated': '{label}: Not evaluated',
  'scores.ariaScoreValue': 'Score value: {score}',
  'scores.severityCritical': 'Critical',
  'scores.severityHigh': 'High',
  'scores.severityMedium': 'Medium',
  'scores.severityLow': 'Low',
  'scores.severityInfo': 'Info',
  'fix.title': 'Fix with AI',
  'fix.lead': 'Propose a branch-based remediation for a finding. HMVM Reviewer does not auto-merge or overwrite protected branches.',
  'fix.loading': 'Loading Fix with AI...',
  'fix.failed': 'Failed to load Fix with AI',
  'fix.orchOk': 'HMVM AI orchestrator is configured. Requests are submitted for proposal only.',
  'fix.orchOff': 'Fix with AI is unavailable: HMVM AI orchestrator is not configured. You can still browse findings and past fix runs.',
  'fix.empty': 'No open findings',
  'fix.emptyBody': 'Run an audit first, then request a proposed fix for an open finding.',
  'fix.requestTitle': 'Request a proposed fix',
  'fix.finding': 'Finding',
  'fix.branch': 'Feature branch',
  'fix.baseRef': 'Base ref',
  'fix.requesting': 'Requesting…',
  'fix.request': 'Request proposed fix',
  'fix.recent': 'Recent fix runs',
  'fix.none': 'No fix runs yet.',
  'fix.selectFinding': 'Select a finding',
  'fix.created': 'Fix run {id} created with status {status}. Fixes are proposed on a branch — nothing is applied to protected branches.',
  'fix.openFindings': 'Open findings',
  'fix.appliedFailed': 'applied {applied} / failed {failed}',
  'reaudit.title': 'Re-audit',
  'reaudit.lead': 'Start a new audit from an existing run. Selected Knowledge Pack IDs are copied from the original run.',
  'reaudit.loading': 'Loading re-audit...',
  'reaudit.failed': 'Failed to load re-audits',
  'reaudit.empty': 'No completed audits',
  'reaudit.emptyBody': 'Finish an audit first, then re-run it to compare findings.',
  'reaudit.startFrom': 'Start from existing run',
  'reaudit.original': 'Original audit',
  'reaudit.quick': 'Quick scan',
  'reaudit.starting': 'Starting…',
  'reaudit.start': 'Start re-audit',
  'reaudit.history': 'Re-audit history',
  'reaudit.none': 'No re-audits yet.',
  'reaudit.selectAudit': 'Select an original audit run',
  'reaudit.new': 'new {id}',
  'reaudit.from': 'from {id}',
  'reaudit.score': 'score {n}',
  'evidence.title': 'Evidence',
  'evidence.loading': 'Loading evidence...',
  'evidence.failed': 'Failed to load evidence',
  'evidence.count': '{n} evidence items linked to findings',
  'evidence.countOne': '1 evidence item linked to findings',
  'evidence.searchPh': 'Search file path, snippet, or finding…',
  'evidence.searchAria': 'Search evidence',
  'evidence.empty': 'No evidence yet',
  'evidence.emptyBody': 'Evidence appears here after an audit produces findings with source locations or snippets.',
  'ev.file_line': 'file line',
  'ev.command_output': 'command output',
  'ev.http_observation': 'HTTP observation',
  'ev.browser_observation': 'browser observation',
  'ev.performance_metric': 'performance metric',
  'ev.dependency_analysis': 'dependency analysis',
  'ev.secret_detection': 'secret detection',
  'ev.static_analysis': 'static analysis',
  'status.title': 'System Status',
  'status.lead': 'Backend health and service readiness checks',
  'status.health': 'Health Check',
  'status.readiness': 'Readiness Check',
  'status.checking': 'Checking...',
  'status.ok': 'OK',
  'status.failedBadge': 'Failed',
  'status.ready': 'Ready',
  'status.notReady': 'Not Ready',
  'status.status': 'Status:',
  'status.version': 'Version:',
  'status.environment': 'Environment:',
  'status.overallReady': 'Overall Ready:',
  'status.yes': 'Yes',
  'status.no': 'No',
  'status.componentChecks': 'Component Checks',
  'status.apiEndpoints': 'API Endpoints',
  'status.healthHint': 'Basic health check',
  'status.readyHint': 'Readiness check',
  'status.versionHint': 'Version info',
  'cmd.noResults': 'No results found',
  'cmd.unavailable': 'Unavailable',
  'cmd.navigate': 'Navigate',
  'cmd.select': 'Select',
  'reports.checkStatusAria': 'Check report status',
  'reports.building': 'Report is generating…',
  'projects.add': 'Add project',
  'projects.startAudit': 'Start audit',
  'projects.searchPh': 'Search projects...',
  'projects.shown': '{n} project{plural} • {shown} shown',
  'projects.clearFilters': 'Clear Filters',
  'projects.noMatch': 'No projects match the current filters',
  'audits.start': 'Start audit',
  'audits.noMatch': 'No audits match the current filters',
  'audits.tableAria': 'Audit runs table',
  'audits.colProject': 'PROJECT',
  'audits.colCreated': 'CREATED',
  'audits.colStatus': 'STATUS',
  'audits.colFindings': 'FINDINGS',
  'audits.colRisk': 'RISK',
  'audits.colDuration': 'DURATION',
  'audits.colActions': 'ACTIONS',
  'audits.clearFilters': 'Clear Filters',
  'settings.auditDefaults': 'Audit defaults',
  'settings.auditDefaultsBody': 'Stored in this browser only. Used when starting a new audit.',
  'settings.defaultQuick': 'Default to quick scan',
  'settings.defaultAi': 'Include AI analysis by default',
  'settings.saved': 'Saved',
  'settings.kc': 'Knowledge Control',
  'settings.kcBody': 'Admin token is stored in this tab only (sessionStorage). It is never sent to Settings persistence or displayed after save.',
  'settings.tokenPresent': 'Token present for this tab',
  'settings.clearToken': 'Clear token',
  'settings.pasteToken': 'Paste admin token',
  'settings.saveTab': 'Save for this tab',
  'settings.runtime': 'Runtime',
  'settings.runtimeLoading': 'Loading runtime…',
  'settings.runtimeFailed': 'Failed to load runtime',
  'settings.product': 'Product',
  'settings.environment': 'Environment',
  'settings.fixAi': 'Fix with AI',
  'settings.orchOn': 'Orchestrator configured',
  'settings.orchOff': 'Unavailable — orchestrator is not configured',
  'settings.kcServer': 'Knowledge Control',
  'settings.kcOn': 'Admin token is configured on the server',
  'settings.kcOff': 'Server admin token is not configured',
  'settings.formats': 'Report formats',
  'dialog.failedLoad': 'Failed to load start-audit data',
  'dialog.failedStart': 'Failed to start audit',
  'dialog.failedCreate': 'Failed to create project',
  'dialog.intakeNoProject': 'Intake did not return a project',
  'theme.electric': 'Electric Blue',
  'theme.neutral': 'Neutral',

  'time.justNow': 'just now',
  'time.min': '{n} minutes ago',
  'time.hour': '{n} hours ago',
  'time.day': '{n} days ago',
  'time.minutesAgo': '{n} minutes ago',
  'time.hoursAgo': '{n} hours ago',
  'time.daysAgo': '{n} days ago',
  'time.minuteAgo': '1 minute ago',
  'time.hourAgo': '1 hour ago',
  'time.dayAgo': '1 day ago',

  'rel.same_rule': 'same rule',
  'rel.same_fingerprint': 'same fingerprint',
  'rel.same_file': 'same file',
  'cat.vulnerability': 'vulnerability',
  'cat.insecure_config': 'insecure config',
  'cat.misconfiguration': 'misconfiguration',
  'cat.code_smell': 'code smell',
  'tag.PATTERN': 'pattern',
  'tag.AST': 'AST',
  'tag.SEMANTIC': 'semantic',
  'tag.session-security': 'session-security',

  'attention.failedTitle': '{project}: audit failed',
  'attention.failedBody': 'Open the run and see which step broke.',
  'attention.criticalTitle': '{n} critical in {project}',
  'attention.criticalBody': 'These are holes that leak data or run attacker code.',
  'attention.highTitle': '{n} high in {project}',
  'attention.highBody': 'Serious weaknesses. Close after critical.',
  'attention.otherTitle': 'Review {project}',
  'attention.otherBody': '{n} items found.',
  'attention.open': 'Open',

  'projects.allSources': 'All Source Types',
  'projects.allStatuses': 'All Statuses',
  'projects.filterSourceAria': 'Filter by source type',
  'projects.filterStatusAria': 'Filter by audit status',
  'projects.clearAria': 'Clear all filters',
  'projects.tableAria': 'Projects table',
  'projects.colProject': 'PROJECT',
  'projects.colSource': 'SOURCE',
  'projects.colLastAudit': 'LAST AUDIT',
  'projects.colAudits': 'AUDITS',
  'projects.colStatus': 'STATUS',
  'projects.colRisk': 'RISK',
  'projects.colActions': 'ACTIONS',
  'projects.never': 'Never',
  'projects.rowAria': 'Project {name}, {n} audits, latest status {status}',
  'projects.noneStatus': 'none',

  'audits.searchPh': 'Search audits...',
  'audits.searchAria': 'Search audits',
  'audits.filterStatusAria': 'Filter by status',
  'audits.filterSeverityAria': 'Filter by severity',
  'audits.allStatuses': 'All Statuses',
  'audits.allSeverities': 'All Severities',
  'audits.hasRisk': 'Has Risk (Critical or High)',
  'audits.hasCritical': 'Has Critical',
  'audits.hasHigh': 'Has High',
  'audits.quickScan': 'Quick Scan',
  'audits.tracksCount': '{n} tracks',
  'audits.rowAria': 'Audit for {project}, status {status}, {n} findings',
  'audits.summary': '{n} total audits • Page {page} of {total} • {shown} shown',
  'audits.prevAria': 'Previous page',
  'audits.nextAria': 'Next page',

  'dash.postureCritical': 'Critical security concerns detected ({n} critical findings)',
  'dash.postureHigh': 'High-priority issues requiring attention ({n} high findings)',
  'dash.postureLow': 'Low risk - no critical or high-priority issues detected',
  'dash.failedLoadFallback': 'Failed to load dashboard data',

  'rec.criticalTitle': 'Investigate Critical Findings',
  'rec.criticalBody': '{n} critical security issues require immediate attention',
  'rec.criticalAction': 'View Critical Findings',
  'rec.criticalWhy': 'Critical findings pose immediate security risks',
  'rec.failedTitle': 'Review Failed Audits',
  'rec.failedBody': '{n} audits failed to complete',
  'rec.failedAction': 'View Audits',
  'rec.failedWhy': 'Failed audits may indicate infrastructure or configuration issues',
  'rec.highTitle': 'Review High-Severity Findings',
  'rec.highBody': '{n} high-severity issues found',
  'rec.highAction': 'View High Findings',
  'rec.highWhy': 'High-severity findings should be addressed promptly',
  'rec.runningTitle': 'Monitor Running Audits',
  'rec.runningBody': '{n} audits currently in progress',
  'rec.runningAction': 'Monitor Audits',
  'rec.runningWhy': 'Active audits are in progress',
  'rec.firstTitle': 'Start Your First Audit',
  'rec.firstBody': 'Begin by creating a project and running your first security audit',
  'rec.firstAction': 'Create Project',
  'rec.firstWhy': 'No audits have been run yet',
  'rec.mediumTitle': 'Review Medium-Severity Findings',
  'rec.mediumBody': '{n} medium-severity findings detected',
  'rec.mediumAction': 'View Medium Findings',
  'rec.mediumWhy': 'Medium-severity findings warrant review',
  'rec.allTitle': 'Review All Findings',
  'rec.allBody': '{n} findings across all severity levels',
  'rec.allAction': 'View All Findings',
  'rec.allWhy': 'Findings exist for review',

  'fixAi.title': 'Fix with AI',
  'fixAi.aria': 'Fix with AI - Request automated remediation',
  'fixAi.startRun': 'Start Fix Run',
  'fixAi.startAria': 'Start Fix with AI',
  'fixAi.creating': 'Creating fix run...',
  'fixAi.whatHappens': 'What will happen:',
  'fixAi.createBranch': 'Create feature branch: {branch}',
  'fixAi.apply': 'Apply AI-assisted remediation for this finding',
  'fixAi.tests': 'Run tests to verify fix',
  'fixAi.commit': 'Commit changes to the feature branch',
  'fixAi.important': 'Important:',
  'fixAi.noDeploy': 'Fix with AI does NOT automatically deploy or merge to production. It creates a feature branch that you can review, test, and merge when ready.',
  'fixAi.finding': 'Finding:',
  'fixAi.severity': 'Severity:',
  'fixAi.strategy': 'Strategy:',
  'fixAi.safest': '(safest fixes only)',
  'fixAi.noContext': 'Cannot create fix run: no audit context',
  'fixAi.createFailed': 'Failed to create fix run',
  'fixAi.unknown': 'Unknown error',
  'fixAi.errorTitle': 'Error Creating Fix Run',
  'fixAi.unavailable': 'The HMVM AI service is not currently available.',
  'fixAi.unavailableHint': 'This may be a temporary configuration issue. Contact your administrator if this persists.',
  'fixAi.inProgress': '(in progress)',
  'fixAi.cancelRun': 'Cancel Fix Run',
  'fixAi.cancelling': 'Cancelling...',
  'fixAi.cancelFailed': 'Failed to cancel',
  'fixAi.branchLabel': 'Branch:',
  'fixAi.created': 'Created:',
  'fixAi.started': 'Started:',
  'fixAi.completed': 'Completed:',
  'fixAi.results': 'Results:',
  'fixAi.fixesApplied': 'Fixes Applied:',
  'fixAi.failedCount': 'Failed:',
  'fixAi.finalCommit': 'Final Commit:',
  'fixAi.statusAria': 'Status: {status}',
  'fixAi.backFinding': '← Back to Finding',
  'fixAi.viewAudit': 'View Audit',
  'fixAi.done': 'Done',

  'fixRuns.title': 'FixRun History',
  'fixRuns.failedLoad': 'Failed to load fix runs',
  'fixRuns.batchFailed': 'Batch cancel failed',
  'fixRuns.noAudit': 'No Audit Selected',
  'fixRuns.noAuditBody': 'Please select an audit to view fix run history.',
  'fixRuns.errorTitle': 'Error Loading Fix Runs',
  'fixRuns.auditMeta': 'Audit: {id}... • {n} fix runs',
  'fixRuns.backAudit': '← Back to Audit',
  'fixRuns.search': 'Search',
  'fixRuns.searchPh': 'Branch name, commit SHA...',
  'fixRuns.status': 'Status',
  'fixRuns.clearAll': 'Clear All',
  'fixRuns.selectedOne': '{n} fix run selected',
  'fixRuns.selectedMany': '{n} fix runs selected',
  'fixRuns.cancelSelected': 'Cancel Selected',
  'fixRuns.batchComplete': 'Batch Cancel Complete',
  'fixRuns.cancelled': 'Cancelled: {n}',
  'fixRuns.skipped': 'Skipped: {n} ({reasons})',
  'fixRuns.errors': 'Errors: {n}',
  'fixRuns.dismiss': 'Dismiss',
  'fixRuns.noneMatch': 'No Matching Fix Runs',
  'fixRuns.noneYet': 'No Fix Runs Yet',
  'fixRuns.noneMatchBody': 'Try adjusting your filters.',
  'fixRuns.noneYetBody': 'Fix runs will appear here after you request fixes.',
  'fixRuns.tableAria': 'FixRun History',
  'fixRuns.selectAllAria': 'Select all cancellable fix runs',
  'fixRuns.colId': 'ID',
  'fixRuns.colStatus': 'Status',
  'fixRuns.colBranch': 'Branch',
  'fixRuns.colBase': 'Base Ref',
  'fixRuns.colApplied': 'Applied',
  'fixRuns.colFailed': 'Failed',
  'fixRuns.colCreated': 'Created',
  'fixRuns.colCompleted': 'Completed',
  'fixRuns.showing': 'Showing {shown} of {total} fix runs',
  'fixRuns.nextPage': 'Next Page →',
  'fixRuns.confirmTitle': 'Confirm Batch Cancel',
  'fixRuns.confirmLead': 'You are about to cancel',
  'fixRuns.confirmOne': 'fix run',
  'fixRuns.confirmMany': 'fix runs',
  'fixRuns.confirmNote': 'This action cannot be undone.',
  'fixRuns.confirmHint': 'Note: Only pending or running fix runs will be cancelled. Completed or already terminal runs will be skipped.',
  'fixRuns.confirmCancel': 'Confirm Cancel',
  'fixRuns.auditNotFound': 'Audit not found',
  'fixRuns.notFound': 'Fix run not found',
  'fixRuns.detailTitle': 'Fix Run Detail',
  'fixRuns.applied': 'Fixes Applied',
  'fixRuns.failedFixes': 'Fixes Failed',
  'fixRuns.execDetails': 'Execution Details',
  'fixRuns.baseRef': 'Base Reference',
  'fixRuns.backHistory': '← Back to History',
  'fixRuns.nextSteps': 'Proposed fixes stay on the feature branch. Review the branch before merging. Nothing is applied to protected branches automatically.',
  'fixRuns.errorDetail': 'Error Loading Fix Run',

  'audit.viewAllAria': 'View all findings for this audit',
  'audit.viewCriticalAria': 'View critical findings for this audit',
  'audit.viewHighAria': 'View high severity findings for this audit',
  'audit.viewMediumLowAria': 'View medium and low severity findings for this audit',

  'cmd.aria': 'Quick navigation',
  'modal.closeAria': 'Close modal',
  'code.copyAria': 'Copy code',
  'empty.generic': 'Something went wrong',
  'empty.retry': 'Try Again',
  'common.loadingDots': 'Loading...',
  'common.copy': 'COPY',
  'common.copied': 'COPIED',

  'preflight.notFound': 'Preflight Not Found',
  'preflight.title': 'Preflight Analysis',
  'preflight.scannerVersion': 'Scanner Version',
  'preflight.projectId': 'Project ID',
  'preflight.sourceId': 'Source ID',
  'preflight.stats': 'Scan Statistics',
  'preflight.totalFiles': 'Total Files',
  'preflight.tech': 'Detected Technologies ({n})',
  'preflight.risky': 'Risky Artifacts ({n})',
  'preflight.secrets': 'Secret Indicators ({n})',
  'preflight.commands': 'Declared Commands ({n})',
  'preflight.failed': 'Failed to load preflight',
  'preflight.loading': 'Loading preflight analysis...',
  'preflight.notFoundBody': 'The requested preflight analysis was not found.',
  'preflight.decision': 'Decision',
  'preflight.safe': 'Safe to Proceed',
  'preflight.blocked': 'Blocked',
  'preflight.reasons': 'Reasons:',
  'preflight.blockers': 'Blockers:',
  'preflight.scanned': 'Scanned',
  'preflight.skipped': 'Skipped',
  'preflight.colName': 'Name',
  'preflight.colCategory': 'Category',
  'preflight.colVersion': 'Version',
  'preflight.colConfidence': 'Confidence',
  'preflight.andMore': '... and {n} more',
  'preflight.secretsHint': 'All secrets are redacted. Only indicators and categories are shown.',
  'preflight.line': 'Line {n}',
  'preflight.commandsHint': 'Commands discovered in package.json, Makefile, etc. (never executed)',
  'preflight.source': 'Source: {file}',
  'preflight.riskyBadge': 'RISKY',
  'preflight.succeeded': 'SUCCEEDED',
  'preflight.succeededWarn': 'SUCCEEDED WITH WARNINGS',
  'preflight.blockedStatus': 'BLOCKED',
  'preflight.failedStatus': 'FAILED',

  'kc.actionFailed': 'Action failed',
  'kc.addMemberFailed': 'Add member failed',
  'kc.removeMemberFailed': 'Remove member failed',
  'kc.updateFailed': 'Update pack failed',
  'kc.versionFailed': 'Create version failed',
  'kc.resolveFailed': 'Resolve failed',

  'filter.allSeverities': 'All Severities',
  'filter.allTracks': 'All Tracks',
  'filter.allStatuses': 'All Statuses',
  'filter.codeQuality': 'Code Quality',
  'filter.businessLogic': 'Business Logic',
  'filter.dependencies': 'Dependencies',
  'filter.performance': 'Performance',
  'filter.infrastructure': 'Infrastructure',
  'filter.investigating': 'Investigating',
  'filter.falsePositive': 'False Positive',
  'filter.wontFix': "Won't Fix",
  'filter.searchFindings': 'Search findings...',
}

export const MESSAGES: Record<Locale, Dict> = { ru, en }

export function isLocale(value: string | null | undefined): value is Locale {
  return value === 'ru' || value === 'en'
}

export function readLocale(): Locale {
  if (typeof window === 'undefined') return 'ru'
  try {
    const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY)
    if (isLocale(stored)) return stored
  } catch {
    /* ignore */
  }
  return 'ru'
}

export function writeLocale(locale: Locale): void {
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  } catch {
    /* ignore */
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale
  }
}

export function interpolate(template: string, vars?: Record<string, string | number>): string {
  if (!vars) return template
  return template.replace(/\{(\w+)\}/g, (_, key: string) =>
    vars[key] === undefined ? `{${key}}` : String(vars[key])
  )
}

export function translate(
  locale: Locale,
  key: string,
  vars?: Record<string, string | number>,
): string {
  const table = MESSAGES[locale] || ru
  const raw = table[key] ?? MESSAGES.en[key] ?? key
  return interpolate(raw, vars)
}

export function statusLabel(locale: Locale, status: string): string {
  const key = `status.${(status || '').toLowerCase()}`
  const hit = MESSAGES[locale][key]
  if (hit) return hit
  return status.replace(/_/g, ' ')
}

export function severityLabel(locale: Locale, severity: string): string {
  const key = `severity.${(severity || '').toLowerCase()}`
  return MESSAGES[locale][key] || severity
}

export function confidenceLabel(locale: Locale, confidence: string): string {
  const key = `conf.${(confidence || '').toLowerCase()}`
  return MESSAGES[locale][key] || confidence
}

export function trackLabel(locale: Locale, track: string): string {
  const key = `track.${(track || '').toLowerCase()}`
  return MESSAGES[locale][key] || track.replace(/_/g, ' ')
}

export function evidenceTypeLabel(locale: Locale, evidenceType: string): string {
  const key = `ev.${(evidenceType || '').toLowerCase()}`
  return MESSAGES[locale][key] || evidenceType.replace(/_/g, ' ')
}

export function lifecycleLabel(locale: Locale, status: string): string {
  const key = `life.${(status || '').toLowerCase()}`
  return MESSAGES[locale][key] || status
}

export function validationLabel(locale: Locale, status: string): string {
  const key = `val.${(status || '').toLowerCase()}`
  return MESSAGES[locale][key] || status
}

export function formatLabel(locale: Locale, format: string): string {
  const key = `fmt.${(format || '').toLowerCase()}`
  return MESSAGES[locale][key] || format
}

export function tagLabel(locale: Locale, tag: string): string {
  const raw = tag || ''
  const hit =
    MESSAGES[locale][`tag.${raw}`] ||
    MESSAGES[locale][`tag.${raw.toUpperCase()}`] ||
    MESSAGES[locale][`tag.${raw.toLowerCase()}`]
  return hit || raw
}

export function actionLabel(locale: Locale, action: string): string {
  const key = `act.${action}`
  return MESSAGES[locale][key] || action.replace(/_/g, ' ')
}

export function packDisplayName(locale: Locale, packId: string, fallback: string): string {
  if (locale !== 'ru') return fallback
  return RU_PACK_NAMES[packId] || fallback
}

export function categoryLabel(locale: Locale, category: string): string {
  const key = `cat.${(category || '').toLowerCase()}`
  return MESSAGES[locale][key] || category.replace(/_/g, ' ')
}

export function formatDateTime(locale: Locale, iso: string | null | undefined): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleString(locale === 'ru' ? 'ru-RU' : 'en-US')
}

export function formatDate(locale: Locale, iso: string | null | undefined): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleDateString(locale === 'ru' ? 'ru-RU' : 'en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}
